export default {
	italian: "Italiano",
	english: "Inglés",
	japanese: "Japonés",
	french: "Francés",
	german: "Alemán",
	spanish: "Español",
	pause_game: "Pausar juego",
	resume_game: "Reanudar juego",
	map_config: {
		select: "Configuración de mapa",
		none: "Sin configuración",
		save: "Guardar configuración",
		load: "Cargar configuración",
		save_new: "Crear nueva configuración",
		save_overwrite: "Sobreescribir existente",
		save_mode: "Modo de guardado",
		name: "Nombre de la configuración",
		name_optional: "Nuevo nombre (opcional)",
		name_placeholder: "Ej: Centro histórico",
		keep_name: "Se conservará el nombre: {name}",
		overwrite_warning: "Se sobreescribirá la configuración seleccionada. Esta acción no se puede deshacer.",
		load_warning: "La configuración actual del mapa se sobreescribirá con la seleccionada.",
		locked_center: "El punto inicial está bloqueado por la configuración de mapa seleccionada.",
		no_template: "Selecciona una plantilla para gestionar configuraciones de mapa.",
		saved: "Configuración guardada correctamente",
		loaded: "Configuración cargada correctamente",
		save_error: "No se pudo guardar la configuración",
		load_error: "No se pudo cargar la configuración",
		loading_map: "Cargando mapa...",
		disabled_event_started: "No se puede cambiar la configuración con el evento iniciado",
	},
	preview: {
		common_sense: {
			title: "Preview Common Sense",
			open_preview: "Vista previa",
			unsaved_warning: "Esta preview muestra cambios del borrador que todavía no están guardados.",
			start_game: "Iniciar juego",
			spin_roulette: "Girar ruleta",
			show_rules: "Ver reglas",
			next_phase: "Siguiente fase",
			finish_challenge: "Terminar reto",
			show_final_ranking: "Ranking final",
			show_challenge_ranking: "Ranking del reto",
			show_result: "Ver resultado",
			back_to_roulette: "Volver a ruleta",
			back_to_waiting_room: "Volver a sala de espera",
			resume_game: "Volver al juego",
			collapse_controls: "Ocultar controles",
			expand_controls: "Mostrar controles",
			hint_explorer: "Modo explorador: muévete entre pantallas.",
			hint_game_flow: "Modo juego: selecciona un reto y sigue el flujo del juego.",
			hint_select_round:
				"Selecciona un reto y, si quieres, un booster para configurar cada ronda de la vista previa.",
			hint_collapse:
				"Puedes ocultar este panel con la flecha para ver la pantalla del jugador a pantalla completa. Ábrelo de nuevo cuando quieras con el botón flotante.",
			tutorial_step_explorer: "Paso 1 · Modo explorador",
			tutorial_step_game: "Paso 2 · Modo juego",
			tutorial_step_select: "Paso 1 · Reto y booster",
			tutorial_step_collapse: "Paso 2 · Ocultar controles",
			tutorial_finish: "Finalizar",
			dismiss_hints: "Entendido",
			tutorial_live_sync_title: "Vista previa en vivo",
			tutorial_live_sync_text:
				"Los cambios que hagas en la plantilla se actualizan automáticamente en esta vista previa. No necesitas recargar la página: edita y comprueba el resultado al momento.",
			jump_to_phase: "Saltar a fase",
			step_waiting: "Sala de espera",
			step_roulette: "Ruleta",
			step_rules: "Reglas",
			step_play: "Reto",
			step_result: "Resultado",
			step_challenge_ranking: "Ranking reto",
			step_final_ranking: "Ranking final",
		},
	},
	general: {
		are_you_sure: "¿Estás seguro?",
		preview_not_able: "No se puede previsualizar este contenido",
		gateway_preview_language: "Idioma",
		gateway_preview_settings: "Settings",
		download: "Descargar",
		budget: "Presupuesto",
		download_pdf: "Descargar PDF",
		download_image: "Descargar imagen",
		play_video: "Reproducir video",
		slides: "Diapositivas",
		change: "Cambiar nombre",
		wrong_link: "El link no es válido o ha expirado, por favor, contacta la persona que te ha enviado el link.",
		test_speed: "Probar velocidad de conexión",
		testing_speed: "Probando Velocidad...",
		speed_test_results: "Resultados de la prueba de velocidad",
		speed_test_failed: "Error al probar la velocidad",
		unable_to_complete_speed_test: "No se ha podido completar la prueba de velocidad. Por favor, inténtalo de nuevo.",
		excellent_speed: "Excelente velocidad!",
		good_speed: "Buena velocidad!",
		slow_speed: "Velocidad lenta!",
		your_connection_is_very_fast: "Tu conexión es muy rápida!",
		your_connection_is_decent: "Tu conexión es decente!",
		your_connection_needs_improvement: "Tu conexión necesita mejorar!",
		test_audio: "Probar audio",
		testing_audio: "Reproduciendo audio...",
		stop_audio: "Parar audio",
		audio_test_results: "Prueba de audio",
		audio_test_success: "Si has oído el sonido, el audio funciona correctamente.",
		audio_test_failed: "Error al probar el audio",
		unable_to_complete_audio_test: "No se ha podido reproducir el audio. Comprueba el volumen y los permisos del dispositivo.",
		join: "Unirse",
		point_gain: "Puntos ganados",
		point_loss: "Puntos perdidos",
		accept_event: "Quieres aceptar este evento?",
		reject: "Rechazar",
		one_vs_all_questions: "Preguntas 1 vs todos",
		question: "Pregunta",
		history: "Historial",
		acceptAll: "Aceptar todos",
		delivered: "Entregado",
		pending: "Pendiente",
		close: "Cerrar",
		collabo_title: "Aplicacion de Colaboracion",
		copy_link: "Copiar enlace",
		go_to_link: "Ir al enlace",
		enter_team_name: "Introduce el nombre del equipo",
		organizer_options: "Opciones del monitor",
		staff_warning: "No tocar nada si no eres miembro del staff",
		accept: "Aceptar",
		not_answered: "No respondida",
		name_company: "Teaming App",
		back: "Atrás",
		go: "Ir",
		select: "Seleccionar",
		next: "Siguiente",
		team: "Equipo",
		teams: "Equipos",
		round: "Ronda",
		ranking: "Ranking",
		results: "Resultados",
		total: "Total",
		remaining: "Restante",
		round_remaining: "Ronda restante",
		answer: "Responder",
		units: "Unidades",
		shop: "Tienda",
		ingredients: "Ingredientes",
		rices: "Arroces",
		plates: "Platos",
		choosing: "Eligiendo",
		save: "Guardar",
		saved: "Guardado",
		cancel: "Cancelar",
		name: "Nombre",
		buy: "Comprar",
		photo: "Foto",
		redo: "Rehacer",
		password: "Contraseña",
		exit: "Salir",
		canceled: "Cancelado",
		event: "Evento",
		day: "Día",
		ingredient: "Ingrediente",
		points: "Puntos",
		position: "Posición",
		agency: "Distribuidor",
		delete: "Eliminar",
		updated: "actualizado",
		created: "creado",
		update: "actualizar",
		create: "crear",
		filters: "Filtros",
		apply_filters: "Aplicar filtros",
		clear_filters: "Borrar filtros",
		search: "Buscar",
		add: "Añadir",
		start: "Empezar",
		from: "Hasta",
		error: "Error",
		chat: "Mensajes",
		game_master: "STAFF",
		options: "Opciones",
		reactions: "Reacciones",
		team_name: "Nombre de equipo",
		option_organizer: "Opciones del monitor",
		btn_send_answer: "Enviar respuesta",
		btn_continue: "Continuar",
		correct_answer: "Respuesta correcta",
		incorrect_answer: "Respuesta incorrecta",
		challenge_complete: "Reto completado",
		instructor: "Monitor",
		edit: "Editar",
		unsaved_changes: "Hay cambios sin guardar",
		en: "Inglés",
		es: "Español",
		yes: "Si",
		no: "No",
		ipad_title: "Scavenger Hunt App",
		tapas_title: "Culinary App",
		utq_title: "Rally App",
		action_title: "Contest App & Construction App",
		cluedo_ai_title: "Aplicación de Investigación",
		bingo_title: "Bingo Musical App",
		common_sense_title: "Aplicacion Common Sense",
		hours: "Horas",
		minutes: "Minutos",
		new: "Nuevo",
		mark_all_read: "Marcar todo como leido",
		name_app: "TEAMING APP",
		hello: "Hola",
		reload_app: "Recargar aplicación",
		change_monitor: "Cambiar monitor",
		must: "Obligatorio",
		first: "Primero",
		you: "Tú",
		try_again: "Error, vuelve a intentarlo",
		incorrect_fields: "Hay campos incorrectos en el formulario",
		save_changed: "Cambio guardado",
		ranking_block: "El administrador ha ocultado el ranking",
		ranking_hidden: "El ranking está escondido",
		ranking_display: {
			normal: "Normal",
			cooperative: "Cooperativo",
			both: "Ambos",
			hidden: "Oculto",
			slides: "Diapositivas"
		},
		answer_correct: "Respuesta correcta",
		answer_incorrect: "Respuesta incorrecta",
		pair_a: "Pareja A ",
		pair_b: "Pareja B ",
		order_colon: "Orden: ",
		quiz_multi: "Cuestionario multiple",
		answer_auto: "Respuesta autocorregida",
		order: "Order",
		click_add: "Click para añadir",
		click_upload: "Click para subir",
		upload: "Subir",
		uploading: "Subiendo...",
		quiz: "Cuestionario",
		pairs: "Parejas",
		min_answers: "Tiene que haber un minimo de {min} respuestas",
		max_answers: "El limite de respuestas son {max}",
		file_large: "Archivo demasiado pesado el maximo son 50MB",
		new_item: "Nuevo item",
		new_contact: "Nuevo contacto",
		add_item: "Añade un item",
		add_contact: "Añade un contacto",
		missing_items: "No hay ningun item añadido",
		missing_contacts: "No hay ningun contacto añadido",
		select_item: "Selecciona un item",
		select_contact: "Selecciona un contacto",
		total_price: "Total {total_price}€",
		app_activity_plus: "+ App Actividad",
		app_activity: "App Actividad",
		url_admin: "Link de Setup",
		url_gm: "Link del monitor",
		preview: "Previsualización",
		actions: "Acciones",
		challenges: "Retos",
		all: "Todos",
		demo_upper: "DEMO",
		demo_mode: "Modo demo",
		start_demo_mode: "Iniciar modo demo",
		stop_demo_mode: "Detener modo demo",
		demo_mode_title: "Iniciar modo demo",
		demo_mode_stop_title: "Detener modo demo",
		demo_mode_info_duration: "El modo demo tendrá una duración máxima de 30 minutos.",
		demo_mode_info_alert: "Los jugadores verán una alerta indicando que están en modo demo.",
		demo_mode_info_reset: "Todo el contenido generado durante la demo será borrado.",
		demo_mode_info_stop: "La demo se podrá detener manualmente desde el mismo botón.",
		demo_mode_time_left: "Tiempo restante de demo: {time}",
		demo_mode_confirm_start: "Iniciar demo",
		demo_mode_confirm_stop: "Detener demo y reiniciar",
		demo_mode_started: "Modo demo iniciado",
		demo_mode_stopped: "Modo demo detenido y partida reiniciada",
		demo_mode_banner: "Estás jugando en modo demo. El progreso se borrará.",
		demo_mode_active: "El modo demo está activo",
		invalid_url: "La URL no es válida",
		open: "Abrir",
		chat_with_gm: "Chat con el monitor",
		cluedo_ai_act: "Aplicación de Investigación",
		submit: "Enviar",
		not_started: "El juego todavía no ha comenzado",
		no_picture: "No hay foto de equipo",
		upload_team_picture: "Foto de equipo",
		plates_rices: "Platos/Arroces",
		done: "Superado",
		challenge: "Reto",
		no_data: "No hay datos",
		link_monitors: "Vincular Facilitadores",
	
		show_qr: "Mostrar código QR",
		slides_tooltip: "Imágenes que se pueden mostrar en la pantalla del ranking par explciar o empezar el juego.",
	},
	join_lobby: {
		title: "Unirse al lobby",
		subtitle: "Introduce tu nombre y espera hasta que el personal cree los equipos.",
		enable: "Activar Sala de Espera",
		demo_disabled: "JoinLobby no se puede activar en eventos demo.",
		use_locations: "Usar ubicaciones",
		locations_before_link_hint:
			"Asegúrate de que las ubicaciones están configuradas correctamente antes de compartir el enlace del lobby con los jugadores.",
		locations: "Ubicaciones",
		locations_placeholder: "Escribe una ubicación y pulsa enter",
		location: "Ubicación",
		location_placeholder: "Selecciona tu ubicación",
		name_placeholder: "Introduce tu nombre",
		join_lobby: "Sala de espera",
		waiting_staff: "Estás en el lobby. El personal creará los equipos pronto.",
		players_online: "Jugadores en línea",
		no_location: "Sin ubicación",
		join_random_team: "Unirse a un equipo aleatorio",
		staff_title: "Ajustes JoinLobby",
		lobby_link: "Enlace del lobby",
		players_per_team: "Jugadores por equipo",
		players_per_team_location: "Jugadores por equipo ({location})",
		teams: "Equipos",
		total_players: "Total de jugadores",
		total_players_with_count: "Total de jugadores: {count}",
		total_teams_with_count: "Total de equipos: {count}",
		teams_will_be_created: "Se crearán {count} equipos",
		teams_already_created_message:
			"Los equipos ya están creados. Los jugadores ya pueden unirse a un equipo aleatorio usando la URL del lobby de arriba.",
		create_teams: "Crear equipos",
		teams_created: "Equipos creados",
		button_tooltip: "Permite que los jugadores se unan a las actividades y luego formen los equipos",
		enable_tooltip: "Permite que los participantes entren en una sala de espera para crear equipos aleatoriamente o acceder a equipos predefinidos. Se utiliza principalmente en actividades online o en casos concretos.",
	},
	analytics: {
		feedback_tab: "Feedback",
		budget_tab: "Presupuesto",
		events_tab: "Eventos",
		budget_coming_soon: "Página de presupuesto (próximamente)",
		number_of_events: "Número de eventos",
		total_eur: "Total €",
		mean_eur_event: "Media € Evento",
		mean_eur_teambuilding_event: "Media € Evento Teambuilding",
		mean_pax_event: "Media Pax Evento",
		show_plot_1: "Mostrar Gráfico 1",
		show_plot_2: "Mostrar Gráfico 2",
		month_1: "Enero",
		month_2: "Febrero",
		month_3: "Marzo",
		month_4: "Abril",
		month_5: "Mayo",
		month_6: "Junio",
		month_7: "Julio",
		month_8: "Agosto",
		month_9: "Septiembre",
		month_10: "Octubre",
		month_11: "Noviembre",
		month_12: "Diciembre",
		number_of_budget: "Número de presupuestos",
		number_of_closed_budget: "Número de presupuestos cerrados",
		number_of_lost_budget: "Número de presupuestos perdidos",
		percent_of_closed_budget: "% de presupuestos cerrados",
		number_of_open_budget: "Número de presupuestos abiertos",
		number_of_won_budget: "Número de presupuestos ganados",
		all_months: "Todos los meses",
		anual_income: "Ingresos anuales",
		type_of_activity: "Actividad",
		type_of_event_budget: "Tipo de evento",
		euro_event: "€ Evento",
		euro_extra: "€ Extra",
		event_place: "Ubicación de eventos",
		review_summary: "Resumen de Reseñas",
		total_events: "Total de Eventos",
		events_with_reviews: "Eventos con Reseñas",
		review_rate: "Tasa de Reseñas",
		category_averages: "Promedios por Categoría",
		review_details: "Detalles de Reseñas",
		expectations: "Expectativas",
		scale: "Escala",
		game_masters: "Game Masters",
		content: "Contenido",
		service_prices: "Servicio/Precios",
		organization: "Organización",
		hire_again: "Contratar de Nuevo",
		reviews: "reseñas",
		event_id: "ID del Evento",
		activity: "Actividad",
		overall_scale: "Escala General",
		stars: "estrellas"
	},
	menu: {
		analytics: "Analytics",
		sales: "Ventas",
		budgets: "Presupuestos",
		clients: "Clientes",
		bookings: "Reservas",
		booking_list: "Lista de reservas",
		calendar: "Calendario",
		summaries: "Resúmenes",
		activities: "Actividades",
		demos: "Demos",
		content: "Contenido",
		settings: "Plantillas",
		settings_erp: "Configuración",
		organization: "Organización",
		activities_erp: "Catálogo",
		event_service: "Servicios de evento",
		extras: "Página extras",
		final_page_budget: "Página final presupuesto",
		activities_questions: "Preguntas de la reserva",
		credits_consumption: "Consumo de créditos",
		superadmin: "Superadmin",
		superadmin_credits: "Créditos (todas las orgs)",
		superadmin_organization_stats: "Estadísticas por org",
		favorite_photos: "Fotos favoritas",
		app_personalization: "Personalización de la app",
		integrations: "Integraciones",
		add_staff: "+ Añadir monitor",
		my_activities: "Mis actividades",
		staff: "Monitor",
		notifications: "Notificaciones",
		changelog: "Novedades",
		logout: "Cerrar sesión",
		switch_organization_label: "Organización activa",
		switch_organization_confirm_title: "¿Cambiar de organización?",
		switch_organization_confirm_message: "Vas a trabajar como \"{name}\". La página se recargará y puede perderse lo no guardado.",
		switch_organization_confirm: "Cambiar",
		switch_organization_error: "No se pudo cambiar de organización"
	},
	superadmin: {
		credits: {
			title: "Créditos de todas las organizaciones",
			subtitle: "Agrupa consumos por mes para facturar y anular partidas de prueba",
			filters: "Filtros",
			organization: "Organización",
			organization_filter_mode: "Modo orgs",
			organization_include: "Incluir seleccionadas",
			organization_exclude: "Excluir seleccionadas",
			all_organizations: "Todas las organizaciones",
			year: "Año",
			month: "Mes",
			status: "Estado",
			apply: "Aplicar",
			total_lines: "Líneas",
			total_credits: "Créditos",
			total_amount: "Importe",
			monthly_summary: "Resumen mensual",
			rows_count: "{count} periodos",
			empty_state: "No hay consumos con estos filtros",
			empty_lines: "No hay líneas en este periodo",
			col_organization: "Organización",
			col_period: "Periodo",
			col_lines: "Líneas",
			col_credits: "Créditos",
			col_amount: "Importe",
			col_status: "Estado",
			col_actions: "Acciones",
			col_date: "Fecha",
			col_event: "Partida",
			col_activity: "Actividad",
			view_lines: "Ver líneas",
			ensure_batch: "Crear lote",
			ensure_batches_all: "Crear lotes (todos)",
			batches_ensured_all: "Lotes listos: {count} (fallidos: {failed})",
			batches_ensured_partial: "Algunos lotes fallaron ({failed})",
			mark_invoiced: "Facturado",
			mark_paid: "Pagado",
			mark_voided: "Anular lote",
			manual_invoice: "Factura manual",
			manual_invoice_dialog_title: "Factura manual",
			manual_invoice_dialog_intro:
				"Se marcará como facturado el periodo {org} · {period} sin enviarlo a Holded.",
			manual_invoice_reference: "Referencia de factura (opcional)",
			manual_invoice_reference_placeholder: "Ej. FAC-2026-001",
			manual_invoice_confirm: "Marcar como facturado",
			manual_invoice_success: "Factura manual registrada ({org} · {period})",
			send_holded: "Holded",
			holded_soon: "Integración Holded próximamente",
			holded_create: "Crear en Holded",
			holded_approve: "Aprobar Holded",
			holded_send: "Enviar email",
			holded_send_invoice: "Enviar factura Holded",
			holded_create_and_email: "Crear + email",
			holded_approve_and_email: "Crear + aprobar + email",
			holded_already_sent: "Enviada a Holded",
			holded_create_email_dialog_title: "Crear factura y enviar email",
			holded_create_email_dialog_intro: "Se creará la factura en Holded (borrador) y se enviará por email.",
			holded_send_dialog_title: "Enviar factura con Holded",
			holded_send_dialog_intro: "Se creará, aprobará y enviará la factura de este periodo de créditos en Holded.",
			holded_flow_create_email: "Crear + email: genera el borrador en Holded y envía el correo (sin aprobar).",
			holded_flow_approve_email: "Crear + aprobar + email: genera, aprueba y envía la factura completa.",
			holded_send_dialog_step_create: "Se creará la factura en Holded con los créditos del periodo.",
			holded_send_dialog_step_approve: "La factura se aprobará automáticamente.",
			holded_send_dialog_step_email: "Se enviará un correo electrónico automáticamente a la organización ({org} · {period}).",
			holded_send_dialog_note: "Usa el email de facturación configurado en la organización. Revisa que tenga ID de Holded y billing mail.",
			holded_will_send_to: "El correo se enviará a: {email}",
			holded_contact_ok: "Holded contact ID configurado: {id}",
			holded_missing_billing_mail: "No se puede enviar: la organización no tiene billing_mail configurado.",
			holded_missing_contact: "No se puede enviar: la organización no tiene holded_contact_id configurado.",
			holded_error_approve: "Error al aprobar en Holded: {error}",
			holded_error_send: "La factura se creó pero el email no se pudo enviar: {error}",
			holded_send_confirm: "Enviar factura",
			holded_create_and_email_confirm: "Crear y enviar",
			holded_approve_and_email_confirm: "Crear, aprobar y enviar",
			holded_create_email_success: "Borrador creado y enviado a {email} (Holded {id})",
			holded_send_invoice_success: "Factura aprobada y enviada a {email} (Holded {id})",
			holded_create_success: "Borrador Holded creado ({id})",
			holded_approve_success: "Factura aprobada en Holded",
			holded_send_success: "Factura enviada por email",
			void_event: "Anular partida",
			void_line: "Anular línea",
			unvoid_line: "Desanular",
			save_line: "Guardar",
			save_line_success: "Línea actualizada",
			lines_locked_holded: "Este periodo ya se envió a Holded. Las líneas no se pueden modificar ni anular.",
			before_void: "antes de anular",
			void_line_confirm: "¿Anular esta línea de créditos?",
			void_line_success: "Línea anulada",
			unvoid_line_success: "Línea restaurada",
			no_event: "Sin partida",
			void_confirm: "¿Anular todos los créditos de \"{name}\"? Esta acción es para quitar pruebas.",
			void_success: "Se anularon {count} líneas",
			batch_ensured: "Lote mensual listo",
			status_updated: "Estado actualizado",
			load_failed: "No se pudo cargar el resumen de créditos",
			load_lines_failed: "No se pudieron cargar las líneas",
			action_failed: "No se pudo completar la acción",
			status_pending: "Pendiente",
			status_invoiced: "Facturado",
			status_paid: "Pagado",
			status_voided: "Anulado",
			month_1: "Enero",
			month_2: "Febrero",
			month_3: "Marzo",
			month_4: "Abril",
			month_5: "Mayo",
			month_6: "Junio",
			month_7: "Julio",
			month_8: "Agosto",
			month_9: "Septiembre",
			month_10: "Octubre",
			month_11: "Noviembre",
			month_12: "Diciembre",
		},
		organization_stats: {
			title: "Estadísticas por organización",
			subtitle: "Créditos y euros vendidos, y actividades hechas (sin anulados). Filtra por organización y periodo.",
			filters: "Filtros",
			hint_individual: "Detalle de la organización seleccionada. Las líneas anuladas no se incluyen.",
			hint_compare: "Totales de todas las organizaciones filtradas. Selecciona una sola para el detalle.",
			back_to_comparison: "Volver a la comparativa",
			organization: "Organización",
			organizations: "Organizaciones",
			organization_filter_mode: "Modo org",
			organization_include: "Incluir seleccionadas",
			organization_exclude: "Excluir seleccionadas",
			year: "Año",
			month: "Mes",
			all_months: "Todos los meses",
			apply: "Aplicar",
			totals: "Totales",
			select_organization: "Selecciona una organización",
			empty_state: "Sin datos de créditos para estos filtros",
			diff_title: "A vs B",
			chart_monthly_credits: "Créditos vendidos por mes",
			chart_monthly_euros: "Euros vendidos por mes",
			chart_monthly_activities: "Actividades hechas por mes",
			chart_activities: "Top actividades por créditos",
			chart_intensity_activities: "Intensidad: créditos por actividad",
			chart_compare_ranking: "Ranking de créditos por organización",
			chart_compare_intensity: "Intensidad: créditos por actividad",
			chart_compare_monthly: "Tendencia mensual de créditos por organización",
			chart_compare_activity_mix: "Mix de actividades por organización",
			table_compare: "Comparativa lado a lado",
			col_metric: "Métrica",
			col_totals: "Totales",
			kpi_credits: "Créditos vendidos",
			kpi_credit_amount: "Euros vendidos",
			kpi_events: "Actividades hechas",
			kpi_activities: "Tipos de actividad",
			kpi_lines: "Líneas de crédito",
			kpi_credits_per_event: "Créditos / actividad",
			kpi_avg_amount_per_event: "€ / actividad",
			metric_credits: "Créditos vendidos",
			metric_credit_amount: "Euros vendidos",
			metric_events: "Actividades hechas",
			metric_activities: "Tipos de actividad",
			metric_lines: "Líneas de crédito",
			metric_credits_per_event: "Créditos / actividad",
			metric_avg_amount_per_event: "€ / actividad",
			visible_rows: "Filas visibles",
			only_with_data: "Solo organizaciones con datos",
			series_credits: "Créditos vendidos",
			series_credit_amount: "Euros vendidos",
			series_events: "Actividades hechas",
			series_credits_per_event: "Créditos / actividad",
			insight_concentration: "Las 3 actividades principales ({activities}) concentran el {percent}% de los créditos",
			load_failed: "No se pudieron cargar las estadísticas",
		},
	},
	changelog: {
		title: "Novedades",
		subtitle: "Últimas actualizaciones y mejoras de la aplicación",
		empty: "Aún no hay novedades publicadas.",
		new: "Nuevo",
		mark_read: "Marcar como leído",
		mark_all_read: "Marcar todo como leído",
		view_all: "Ver todo",
		got_it: "Entendido",
		dismiss: "Cerrar"
	},
	notifications: {
		empty: "No hay notificaciones"
	},
	budgets: {
		currency: "Moneda",
		type: "Tipo",
		activities: "Actividades",
		budget_description: "Descripción del presupuesto",
		placeholder_budget_description: "Descripción del presupuesto",
		budgets: "Presupuestos",
		status: "Estado",
		search: "Buscar",
		search_name: "Buscar por nombre",
		name: "Nombre",
		client: "Cliente",
		people: "Personas",
		date: "Fecha del evento",
		open: "Abierto",
		won: "Ganado",
		lost: "Perdido",
		all: "Todos",
		new_budget: "Nuevo Presupuesto",
		must_name: "Debe tener un nombre",
		budget_validity: "Validez del presupuesto",
		hour: "Hora",
		show_total: "Mostrar total",
		language: "Idioma",
		spanish: "Español",
		english: "Ingles",
		catalan: "Catalán",
		conditions: "Condiciones",
		extras: "Extras",
		budget: "Presupuesto",
		close_budget: "Cerrar Presupuesto",
		download: "Descargar",
		select_option: "Selecciona una opción",
		select_items: "Selecciona los items que se transferiran a la reserva",
		comments_close_budget: "Comentarios sobre el cierre del presupuesto",
		convert: "Convertir",
		close: "Cerrar",
		back: "Volver",
		cancel: "Cancelar",
		line: "Añadir línea",
		line_type: "Linea",
		category: "Categoría",
		budget_type: "Tipo de Presupuesto",
		auto_price: "Precio Automatico",
		total: "Total",
		description: "Descripción",
		price_tag: "Tag precio",
		pax: "Personas",
		price: "Precio",
		user: "Usuario",
		no_condition: "Sin condiciones",
		comments: "Comentarios Internos",
		activity: "Actividad",
		location: "Ubicación",
		item: "Item",
		first: "Primero",
		close_convert: "Cerrar/Convertir presupuesto",
		comments_budget: "Añadir comentarios en el presupuesto",
		bulk_add_button: "Añadir múltiples actividades",
		bulk_add_title: "Añadir múltiples actividades",
		bulk_select_categories: "Selecciona las categorías de actividades",
		bulk_categories_placeholder: "Seleccionar categorías...",
		bulk_or_search_activities: "O salta las categorías y busca en todo el catálogo.",
		bulk_browse_all_activities: "Buscar en todas las actividades",
		bulk_select_activities_all: "Busca y selecciona actividades en todo el catálogo",
		bulk_no_activities_loaded: "No hay actividades disponibles para añadir",
		bulk_select_activities: "Selecciona las actividades que quieres añadir",
		bulk_no_activities: "No hay actividades en las categorías seleccionadas",
		bulk_search_activities_placeholder: "Buscar por nombre o código...",
		bulk_no_activities_search: "Ninguna actividad coincide con la búsqueda",
		bulk_pax_hint: "Indica el número de personas para las {count} actividades seleccionadas",
		bulk_default_price_tag: "Etiqueta de precio por defecto",
		bulk_default_price_tag_placeholder: "Selecciona una etiqueta de precio...",
		bulk_default_price_tag_none: "Sin etiqueta por defecto",
		bulk_next: "Siguiente",
		bulk_add_confirm: "Añadir al presupuesto"
	},
	bookingmedia: {
		uploadImages: "Subir imágenes",
		downloadImages: "Descargar imágenes",
		imagesUploaded: "Imagen subida",
		imageRemoved: "Imagen eliminada",
		uploadFailed: "Error al subir la imagen",
		uploadAllFailed: "No se pudo subir ninguna imagen. Comprueba la conexión e inténtalo de nuevo.",
		uploadPartialSuccess: "Se subieron {success} de {total} imágenes. {failed} no se pudieron subir.",
		uploadRetrying: "Reintentando ({attempt}/{max})",
		notSavedForm: "Debes guardar la reserva antes de subir imágenes",
		imageUploaded: "Imagen Subida",
		uploadedImage: "Imagen de la reserva",
		viewImage: "Ver imagen en grande",
		removeImage: "Eliminar imagen",
		removeFailed: "No se pudo eliminar la imagen",
		noImages: "No hay fotos todavía",
		noImagesHint: "Sube imágenes para documentar la reserva",
		photoCount: "{count} foto(s)",
		loadMorePhotos: "Cargar más ({count} restantes)",
		noContent: "No hay imágenes para descargar"
	},
	favoritePhotos: {
		title: "Fotos favoritas",
		subtitle: "Fotos guardadas de las reservas, filtradas por reserva y actividad",
		addFavorite: "Añadir a favoritos",
		removeFavorite: "Quitar de favoritos",
		selectActivity: "Asignar actividad",
		selectActivityHint: "Por defecto se selecciona la primera actividad de la reserva. Puedes buscar y elegir cualquier actividad del catálogo.",
		searchActivity: "Buscar actividad...",
		searchBooking: "Buscar reserva...",
		noFilterResults: "Sin resultados",
		previousPhoto: "Foto anterior",
		nextPhoto: "Foto siguiente",
		downloadError: "No se pudo descargar la imagen",
		selectActivityPlaceholder: "Selecciona una actividad",
		noActivitySearchResults: "No se encontraron actividades",
		noActivitiesCatalog: "No hay actividades en el catálogo",
		noActivitiesInBooking: "Esta reserva no tiene actividades asociadas. La foto se guardará sin actividad.",
		activity: "Actividad",
		noActivity: "Sin actividad",
		added: "Foto añadida a favoritos",
		removed: "Foto eliminada de favoritos",
		addError: "No se pudo añadir a favoritos",
		removeError: "No se pudo quitar de favoritos",
		filterBooking: "Reserva",
		filterActivity: "Actividad",
		allBookings: "Todas las reservas",
		allActivities: "Todas las actividades",
		applyFilters: "Filtrar",
		empty: "No hay fotos favoritas todavía",
		loadingMore: "Cargando más fotos…",
		allPhotosLoaded: "Se han mostrado las {count} fotos"
	},
	bookings: {
		file: "Archivo",
		activity_sheet: "Ficha de la actividad",
		staff_document: "Documento para staff",
		responsible: "Resp",
		crm_id: "ID CRM",
		placeholder_crm_id: "ID CRM",
		pipedrive_deal_search_placeholder: "Buscar deal en Pipedrive…",
		pipedrive_open_deal: "Abrir en Pipedrive",
		pipedrive_loading_deal: "Cargando deal de Pipedrive…",
		pipedrive_deal_not_found: "No se encontró el deal en Pipedrive",
		pipedrive_deal_load_error: "No se pudo cargar el deal de Pipedrive",
		pipedrive_invalid_deal_id: "El ID CRM no es un ID de deal válido de Pipedrive",
		staff_main: "Responsable de producción",
		gm_rejected: "Monitores rechazados",
		accepted: "Estado",
		history_status_pending: "Pendiente",
		history_status_saved: "Guardado",
		history_author: "Autor",
		history_source_client: "Cliente",
		history_source_staff: "Staff",
		history_applied: "Aplicado",
		history_field_booking_item: "Ingresos",
		history_field_cost_item: "Gastos",
		history_field_game_master_record: "Monitores",
		file_archive_title: "Archivo de documentos",
		file_archive_file: "Archivo",
		file_archive_section: "Sección",
		file_archive_status: "Estado",
		agent_suggestions: "Agente IA",
		agent_suggestions_title: "Agente IA",
		agent_suggestions_hint: "El agente revisa los datos de la reserva y, si está conectado, el deal de Pipedrive y su hilo de correos.",
		agent_suggestions_loading: "Analizando reserva...",
		agent_suggestions_refresh: "Volver a analizar",
		agent_priority_high: "Alta",
		agent_priority_medium: "Media",
		agent_priority_low: "Baja",
		agent_pipedrive_included: "Datos de Pipedrive incluidos",
		agent_pipedrive_not_included: "Sin deal de Pipedrive (no conectado o sin CRM ID)",
		agent_pipedrive_emails_included: "{count} correos del deal analizados",
		agent_pipedrive_emails_empty: "Sin correos vinculados al deal",
		agent_pipedrive_emails_error: "No se pudieron leer los correos del deal",
		agent_open_deal: "Abrir deal",
		agent_pipedrive_notes: "Notas CRM",
		agent_field_hint: "Campo",
		agent_no_pending: "No se detectan pendientes claros.",
		agent_disabled: "El agente no está activado en la organización.",
		agent_error: "No se pudieron obtener las sugerencias.",
		file_archive_active: "Activo",
		file_archive_removed: "Eliminado",
		media_files: "Multimedia",
		owner: "Propietario",
		communication_platform: "Plataforma de comunicación",
		communication_url: "URL de comunicación",
		zoom: "Zoom",
		ms_teams: "MSTeams",
		webex: "Webex",
		google_meet: "GMeet",
		general: "General",
		event: "Evento",
		activity_information: "Información de la actividad",
		questions: "Preguntas",
		economics: "Economía",
		ratings: "Valoraciones",
		bookings: "Reservas",
		media: "Media",
		name: "Nombre",
		placeholder_name: "Nombre",
		alert_name: "Debe tener un nombre",
		client: "Cliente",
		people: "Personas",
		pax_tooltip:
			"El número de participantes se cerrará 10 días antes del evento",
		date: "Fecha",
		search_name: "Buscar por nombre",
		search: "Buscar",
		new_booking: "Nueva Reserva",
		language: "Idioma",
		hour: "Hora actividad",
		client_logo: "Logo del cliente",
		logo_client_tooltip:
			"Sube el logo que se utilizará en los materiales y aplicaciones compatibles del evento.",
		billing_data: "Datos de facturación (Nombre empresa, NIF y dirección)",
		billing_data_tooltip:
			"Indica el nombre fiscal, NIF y dirección necesarios para emitir la factura.",
		activities_app: "Actividades App",
		type_event: "Tipo de evento",
		place: "Ubicación",
		url_location: "Enlace Google Maps",
		place_information: "Información del espacio",
		place_information_tooltip: "¿Hay algo más que debamos saber del espacio?",
		location: "Ubicación",
		must_name: "Debe tener un nombre",
		general_information: "Información general",
		company_name: "Nombre de empresa",
		company_name_tooltip: "Persona responsable el día del evento",
		event_general_timing: "Horario general del evento",
		timetable_plain_tooltip:
			"Añade la agenda completa, incluyendo llegadas, reuniones, comidas, actividad y finalización.",
		extra_information: "Información extra",
		extra_information_internal: "Información extra interna",
		timeline: "Horario",
		description: "Descripción",
		add_activity: "Añadir actividad",
		save_before_add_activity: "Debes guardar el formulario antes de añadir actividades.",
		number_teams: "Numero de equipos",
		team_number_tooltip:
			"Número de equipos en los que se dividirá a los participantes.",
		staff_people: "N.º de monitores",
		teams: "Equipos",
		staff: "Monitores",
		add_team: "Añadir equipo",
		add_staff: "+ Añadir monitor",
		contact_person: "Persona de contacto",
		add_person_contact: "Añadir persona de contacto",
		add_item: "Anade un item",
		new_contact: "Nuevo contacto",
		add_questions: "Añadir Preguntas",
		modify_questions: "Modificar preguntas",
		add: "Añadir",
		all_questions: "Todas las preguntas",
		activity_questions: "Preguntas de la reserva",
		costs: "Costes",
		price: "Precio",
		activity: "Actividad",
		activities: "Actividades",
		activity_ies: "Actividad/es",
		reserve_item: "Servicios",
		gm_pay: "Costes de staff",
		add_gm: "+ Añadir monitor",
		game_master: "Monitor",
		monitor_info: "Info del monitor",
		no_visible_monitor_fields: "No hay información visible para este monitor",
		salary: "Salario",
		total: "Total",
		gm_valoration: "Valoración del monitor",
		client_valoration: "Valoración del cliente",
		es: "Español",
		en: "Inglés",
		cat: "Català",
		email: "Email",
		phone: "Telefono",
		extra: "Extra",
		online: "Online",
		in_person: "Presencial",
		booking_activities: "Actividades App",
		name_place: "Nombre del sitio",
		direction_location: "Dirección url sitio",
		add_cost: "Añadir coste",
		add_field: "Añadir campo",
		review_gm_enjoy: "¿Los participantes se lo han pasado bien?",
		review_gm_size: "¿Cómo valoras el dimensionado del equipo de monitores?",
		review_gm_previous_info: "¿Cómo valoras la información previa a la actividad?",
		review_gm_started: "¿Cuándo ha empezado la actividad?",
		review_gm_material: "¿Se ha dañado o perdido algún material?",
		review_gm_comments: "¿Comentarios o incidencias?",
		staff_comments: "Comentarios",
		review_expectations: "¿Hasta que punto nuestros servicios han cumplido tus expectativas?",
		review_scale: "Del 1 al 10, ¿qué tan probable es que recomiendes nuestros servicios a alguien de tu entorno? ",
		review_gamemasters: "¿Cómo calificarías la atención de los dinamizadores en la actividad?",
		review_content: "¿Cómo calificarías el contenido de la actividad?",
		review_service_prices: "¿Cómo calificarías el precio de los servicios?",
		review_previous_organization: "¿Cómo calificarías la organización previa a la actividad?",
		review_hire_again: "¿Cuáles son las probabilidades de que vuelvas a contratar nuestro servicio?",
		review_comments: "¿Tienes algún comentario o sugerencia para nosotros?",
		expected_not: "No han cumplido mis expectativas",
		expected_more: "Me esperaba más",
		expected_fulfilled: "Han cumplido con lo que esperaba",
		expected_exceeded: "Han superado mis expectativas",
		very_unsatisfactory: "Muy insatisfactoria",
		unsatisfactory: "Insatisfactoria",
		neutral: "Neutra",
		satisfactory: "Satisfactoria",
		very_satisfactory: "Muy satisfactoria",
		no_complaints: "No, han habido muchas quejas",
		standing_group: "No mucho, grupo parado",
		generally_yes: "Generalmente sí",
		highly_motivated: "Sí, grupo muy motivado",
		staff_shortage_critic: "Faltaba personal críticamente",
		staff_shortage: "Faltaba personal para ir cómodos",
		correct: "Correcto",
		staff_excess: "Sobraba personal",
		missing_information: "Faltaba información importante",
		missing_details: "Faltaban detalles",
		enough: "Suficiente",
		surplus: "De sobras",
		early_expected: "Más temprano de lo esperado",
		on_point: "En punto",
		ten_late: "0-10 min tarde",
		thirty_late: "10-30 min tarde",
		more_late: "+30 min tarde",
		user: "Usuario",
		timetable: "Horario",
		fundae: "FUNDAE",
		fundae_question: "¿Queréis bonificar esta actividad por FUNDAE? ¿Quién lo gestiona?",
		fundae_option_no: "No",
		fundae_option_organization: "Sí, lo gestiona {name}",
		fundae_option_client: "Sí, lo gestiona el cliente",
		files_fundae_client: "Documentación FUNDAE (para el cliente a rellenar)",
		files_fundae_client_by_client: "FUNDAE CLIENTE — Documentación FUNDAE (para el cliente a rellenar)",
		files_fundae_staff_tooltip:
			"Sube aquí el contrato de encomienda debidamente cumplimentado y firmado. También la lista de participantes rellenada.",
		files_fundae_staff: "Documentación FUNDAE (Rellenada para el cliente)",
		final_client_section: "Cliente final / Intermediario",
		final_client_section_tooltip:
			"Indica si el servicio se contrata directamente o mediante una agencia, venue u otro intermediario.",
		final_client_selector: "¿Eres cliente final o intermediario?",
		final_client_option_client: "Cliente final",
		final_client_option_agency: "Intermediario",
		final_client_name: "Nombre del cliente final",
		final_client_agency: "Nombre del intermediario",
		final_client_white_label:
			"¿El equipo dinamizador puede acudir con vestimenta corporativa o preferís que la intervención se realice en formato de marca blanca?",
		bill_sent: "Factura enviada",
		custom_fields_section: "Campos personalizados",
		contract_section: "Contrato",
		contract_status: "Contrato",
		contract_status_missing_data: "Faltan datos",
		contract_status_pending_client: "Pendiente del cliente",
		contract_status_pending_signature: "Por firmar",
		contract_status_signed: "Firmado",
		contract_status_inactive: "No activado",
		contract_status_signed_hidden: "Firmado (no activado)",
		contract_missing_keys: "Variables pendientes",
		contract_not_activated_title: "Contrato no activado",
		contract_not_activated_hint: "El contrato no está activado en esta reserva. Actívalo para que el cliente pueda verlo y firmarlo.",
		contract_show_to_client: "Activar contrato",
		contract_hide_from_client: "Desactivar contrato",
		contract_show_to_client_success: "Contrato activado",
		contract_hide_from_client_success: "Contrato desactivado",
		contract_reset: "Reiniciar contrato",
		contract_reset_confirm: "Se borrarán la firma, el PDF firmado y todos los campos que haya rellenado el cliente. El cliente podrá volver a completarlos y firmar. ¿Quieres continuar?",
		contract_reset_success: "Contrato reiniciado",
		contract_hint_pending_client: "El cliente ya puede ver el contrato en su link y completar sus campos.",
		contract_hint_pending_signature: "Todo listo. El cliente puede firmar desde su link o descargar el PDF.",
		contract_hint_signed: "El contrato ya está firmado. Puedes descargarlo desde el menú ⋮.",
		contract_download_pdf: "Descargar contrato PDF",
		contract_download_signed: "Descargar contrato firmado",
		contract_fill_client_fields_hint: "Completa los campos marcados en el contrato. Podrás firmar cuando estén rellenos.",
		contract_fill_required_before_next: "Debes rellenar todos los campos antes de pasar a la firma.",
		contract_fill_required_before_sign: "Debes completar el nombre, los campos obligatorios y la firma antes de firmar.",
		contract_sign_choose_option: "Elige una de las dos opciones para firmar el contrato: firmar en la web o descargarlo y subirlo.",
		contract_sign_web: "Firmar en la web",
		contract_signer_name: "Nombre del firmante",
		contract_clear_signature: "Limpiar firma",
		contract_sign: "Firmar contrato",
		contract_sign_cta: "Firmar contrato",
		contract_continue: "Continuar contrato",
		contract_view: "Ver contrato",
		contract_minimize: "Minimizar",
		contract_save_and_continue: "Guardar y continuar a la firma",
		contract_finish_go_booking: "Finalizar e ir a la reserva",
		contract_upload_signed: "Subir contrato firmado",
		contract_upload_signed_hint: "Descarga el PDF, fírmalo y súbelo aquí.",
		contract_upload: "Subir PDF",
		contract_upload_pdf_only: "Solo se permiten archivos PDF",
		contract_signed_success: "Contrato firmado correctamente",
		filter_contract_status_label: "Estado del contrato",
		filter_contract_status_description: "Filtrar reservas por estado del contrato",
		contract_var_name: "Nombre de la reserva",
		contract_var_date: "Fecha",
		contract_var_time: "Hora",
		contract_var_pax: "Personas",
		contract_var_language: "Idioma",
		contract_var_type: "Tipo (online/presencial)",
		contract_var_activity_duration: "Duración",
		contract_var_place_name: "Lugar",
		contract_var_place_url: "URL del lugar",
		contract_var_place_info: "Info del lugar",
		contract_var_place_contact: "Contacto del lugar",
		contract_var_billing_data: "Datos de facturación",
		contract_var_extra_info: "Info extra",
		contract_var_timetable_plain: "Horario",
		contract_var_team_number: "Número de equipos",
		contract_var_contact_persons: "Personas de contacto",
		contract_var_activities: "Actividades (economics)",
		contract_var_total_price: "Precio total (economics)",
		contract_var_budget_number: "Número de presupuesto",
		contract_var_client_name: "Nombre del cliente",
		contract_var_client_email: "Email del cliente",
		contract_var_signed_date: "Fecha de firma",
		contract_var_signed_time: "Hora de firma",
		client_information: "Información del cliente",
		app: "App",
		event_details: "Detalles del evento",
		staff_persons: "Personal",
		incomes: "Ingresos",
		valoration_available: "VALORACIÓN (disponible al finalizar el evento)",
		very_likely: "Muy probable",
		likely: "Probable",
		unlikely: "Poco probable",
		very_unlikely: "Muy improbable",
		close_booking: "Cerrar Reserva",
		agency_files: "Archivos internos",
		client_files: "Archivos del cliente",
		client_files_tooltip:
			"Cualquier archivo necesario para la realización del evento, como la lista de participantes, horarios u otra documentación relevante.",
		invoice_files: "Archivos de factura",
		event_invoice_files: "Facturas de gastos del evento",
		upload_expense_invoice: "Subir factura de gastos",
		upload_expense_invoice_modal_title: "Subir factura de gastos",
		upload_expense_invoice_modal_hint: "Puedes subir una o varias facturas de gastos del evento. No podrás ver las facturas subidas desde aquí.",
		add_file: "Añadir archivo",
		price_tag: "Tag precio",
		item: "Item de reserva",
		line: "Linea",
		pax: "Personas",
		auto_price: "Precio automático",
		done: "Terminadas",
		canceled: "Canceladas",
		open: "Abiertas",
		add_question_warning: "Las preguntas que añadas no se traducirán",
		place_contact: "Contacto del espacio",
		place_contact_tooltip:
			"Datos de la persona responsable o de contacto del espacio.",
		detail_canceled: "CANCELADA",
		detail_open: "ABIERTA",
		detail_closed: "CERRADA",
		status: "Estado",
		filter_dialog_title: "Filtrar reservas",
		filter_state_label: "Estado de la reserva",
		filter_state_description: "Muestra solo reservas en los estados seleccionados (abierta, finalizada o cancelada).",
		filter_owner_label: "Responsable de la reserva",
		filter_owner_description: "Filtra por la persona responsable de la reserva.",
		filter_main_staff_label: "Responsable de producción",
		filter_main_staff_description: "Filtra por el responsable de producción asignado a la reserva.",
		filter_fundae_label: "Subvención FUNDAE",
		filter_fundae_description: "Si la reserva tiene FUNDAE activo (gestionado por la organización o por el cliente).",
		filter_fundae_files_label: "Documentación FUNDAE (Rellenada para el cliente) (2+ archivos)",
		filter_fundae_files_description: "Muestra reservas que tienen al menos dos archivos subidos en la documentación FUNDAE rellenada para el cliente.",
		filter_bill_sent_label: "Factura enviada",
		filter_bill_sent_description: "Si la factura ha sido marcada como enviada para la reserva.",
		filter_language_label: "Idioma del evento",
		filter_language_description: "Idioma configurado para la reserva del evento.",
	
		crm_id_tooltip: "Identificador de la oportunidad o reserva en vuestro CRM externo. Si Pipedrive está conectado, se vincula al deal.",
		contact_person_tooltip: "Contacto principal del cliente para coordinar el evento.",
		place_tooltip: "Nombre del espacio o lugar donde se celebrará el evento.",
		url_location_tooltip: "Añade el enlace de Google Maps con la ubicación exacta del evento.",
		extra_information_tooltip: "Información general de contexto del evento.",
		auto_price_tooltip: "Calcula el precio utilizando la tarifa configurada, el tag de precio y el número de participantes.",
		bill_sent_tooltip: "Márcalo cuando la factura se haya enviado al cliente.",
		responsible_tooltip: "Indica qué monitor será el responsable principal del equipo.",
		gm_valoration_tooltip: "Evaluación interna del monitor sobre el desarrollo de la actividad, el equipo y las posibles incidencias.",
		client_valoration_tooltip: "Opinión del cliente sobre la actividad, la organización y el servicio recibido.",
	},
	activities: {
		activities: "Actividades",
		activity: "App",
		game: "App",
		day: "Dia",
		enter: "Entrar",
		create_activity: "Crear Actividad",
		sure: "Estas seguro?",
		delete: "Eliminar",
		date_hour: "Fecha y hora",
		name_activity: "Nombre de la actividad",
		type_activity: "App",
		language: "Idioma",
		comments: "Comentarios",
		logo: "Logo",
		demo: "Demo",
		demo_locked_tooltip: "Una vez creado el evento, no se puede cambiar a demo ni quitar el demo.",
		alert_name_activity: "Pon un nombre al la actividad.",
		select_language: "Selecciona un idioma",
		select_challenge: "Selecciona algun reto",
		select_date: "Selecciona una fecha",
		select_activity: "Selecciona un tipo de actividad",
		select_name: "Pon un nombre a la actividad",
		select_primary_color: "Selecciona un color primario.",
		select_secondary_color: "Selecciona un color secundario.",
		save_error: "No se ha podido {message_request_negative} el evento",
		save_ok: "Evento {message_request} correctamente",
		delete_error: "No se ha podido eliminar el evento",
		delete_ok: "Se ha eliminado el evento",
		tl_activity: "Actividad {company}",
		click_add: "Click para Añadir",
		dashboard: "Dashboard",
	
		demo_tooltip: "Márcalo para crear una actividad de demostración en lugar de un evento real. Estará limitada a 2 equipos y no consumirá créditos.",
	},
	demos: {
		demos: "Demos",
		create_demo: "Crear Demo"
	},
	content: {
		collabo: {
			presets: "Presets",
			preset: "Preset",
			challenges: "Retos",
			challenge: "Reto",
			challenges_placeholder: "Seleccionar retos",
			videos: "Vídeos Collabo",
			video_item: "Vídeo Collabo",
			videos_placeholder: "Seleccionar vídeos",
			videos_title: "Título",
			description_gm: "Descripción para el monitor",
			video: "Vídeo",
			challenge_type: "Tipo de reto",
			challenge_type_placeholder: "Seleccionar tipo de reto",
			name: "Nombre",
			material: "Material",
			materials: "Materiales",
			materials_placeholder: "Seleccionar materiales",
			construction: "Construcción",
			constructions: "Construcciones",
			constructions_placeholder: "Seleccionar construcciones",
			model3d: "Modelo 3D",
			paint: "Pintar",
			statment: "Declaración",
			make: "Hacer",
			find: "Encontrar",
			find_missing: "Encontrar Faltante",
			image: "Imagen",
			subcontent: "Subcontenido",
			subcontent_placeholder: "ej., city_find, flower_pattern",
			description: "Descripción",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			placeholder_description: "Descripción del reto..."
		},
		content: "Contenido",
		add_new_content: "Nuevo",
		discard_and_new_content: "Se perderán los cambios no guardados. ¿Quieres crear un nuevo contenido?",
		list_content: "Lista de contenido",
		no_template: "Sin plantilla",
		no_act: "Sin caso",
		all: "Todos",
		downloading_content: "Descargando contenido",
		skip_download: "Continuar sin esperar",
		skip_download_hint:
			"Puedes continuar ahora. El resto se descargará en segundo plano cuando haya conexión.",
		background_download_remaining: "{count} pendientes",
		background_download_in_settings: "Descargando el contenido restante…",
		exporting_event_content: "Exportando envíos de jugadores",
		files_remaining: "archivos restantes",
		export_transferring_zip: "Iniciando descarga...",
		export_uploading_s3: "Subiendo ZIP al almacenamiento...",
		export_ready_downloading: "ZIP listo, iniciando descarga...",
		export_download_button: "Descargar ZIP",
		player_asset_cache_title: "Preparando contenido sin conexión",
		player_asset_cache_text:
			"Guardando mapas y archivos en tu dispositivo para poder usarlos sin conexión.",
		cluedo_ai: {
			cluedo_ai_settings: "Templates",
			cluedo_ai_setting: "Configuración Cluedo AI",
			cluedo_ai_title: "Cluedo AI",
			cluedo_ai_act: "Caso",
			cluedo_ai_questions: "Preguntas",
			cluedo_ai_objects: "Objetos",
			cluedo_ai_characters: "Personajes",
			cluedo_ai_object: "Objeto",
			cluedo_ai_character: "Personaje",
			cluedo_ai_question: "Pregunta",
			duration: "Duración",
			placeholder_duration: "Duración de la actividad",
			image_quiz: "Imagen cuestionario",
			image1: "Imagen 1",
			image2: "Imagen 2",
			image3: "Imagen 3",
			description: "Descripción",
			placeholder_description: "Descripción de la actividad",
			name: "Nombre",
			placeholder_name: "Nombre de la actividad",
			id_name: "Nombre identificativo",
			placeholder_id_name: "Nombre identificativo de la actividad",
			alert_id_name: "Pon un nombre identificativo a la actividad",
			templates: "Plantillas",
			act: "Caso",
			no_act: "Sin caso",
			setting: "Configuración",
			character: "Personaje",
			questions: "Preguntas",
			no_character: "Sin personaje",
			no_questions: "Sin preguntas",
			key_information: "Información clave",
			placeholder_key_information: "Información clave",
			placeholder_prompt: "Prompt",
			placeholder_prompt_answer: "Prompt respuesta",
			placeholder_question: "Pregunta",
			placeholder_answer: "Respuesta",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			question: "Pregunta",
			answer: "Respuesta",
			prompt_answer: "Prompt de Respuesta",
			points: "Puntos",
			act_char: "Personaje",
			image: "Imagen",
			model3d: "Modelo 3D",
			prompt: "Prompt",
			start_message: "Mensaje de inicio",
			placeholder_start_message: "Mensaje de inicio",
			background: "Fondo",
			add_key_information: "Añadir información clave",
			age: "Edad",
			placeholder_age: "Edad del personaje",
			job: "Trabajo",
			placeholder_job: "Trabajo del personaje",
			personal_information: "Información personal",
			placeholder_personal_information: "Información personal del personaje",
			personality: "Personalidad",
			placeholder_personality: "Personalidad del personaje",
			context: "Contexto",
			placeholder_context: "Contexto del personaje",
			case_related: "Caso relacionado",
			placeholder_case_related: "Caso relacionado del personaje",
			motivation: "Motivación",
			placeholder_motivation: "Motivación del personaje",
			previous_knowledge: "Conocimientos previos",
			placeholder_previous_knowledge: "Conocimientos previos del personaje",
			relashionship: "Relaciones",
			placeholder_relashionship: "Relaciones del personaje",
			description_player: "Descripción del personaje",
			placeholder_description_player: "Descripción del personaje",
			short_text: "Texto corto"
		},
		ipad: {
			ipad_settings: "Plantillas",
			ipad_setting: "Configuración Ipad",
			ipad_challenges: "Retos digitales",
			must: "Obligatorio",
			optional: "Opcional",
			first: "Primero",
			content_list: "Lista de Contenido",
			name: "Nombre",
			setting: "Configuración",
			type: "Plantilla",
			quiz: "Cuestionario",
			open_text: "Texto libre",
			photo: "Foto",
			video: "Video",
			alert: "Alerta",
			team_photo: "Foto de equipo",
			order: "Order",
			match: "Match",
			type_challenge: "Tipo de reto",
			id_name: "Nombre identificativo",
			password: "Constraseña",
			time: "Tiempo",
			challenge_close_time: "Tiempo para cerrar",
			max_points: "Puntuación máxima",
			template: "Plantilla",
			description: "Descripción",
			file_1: "File 1",
			file_2: "File 2",
			file_3: "File 3",
			placeholder_type: "Selecciona un tipo",
			alert_type: "Selecciona un tipo de reto",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			placeholder_name: "Nombre del reto...",
			placeholder_password: "Contraseña...",
			placeholder_description: "Descripción del reto...",
			expected_answer: "Respuesta Esperada",
			placeholder_expected_answer: "Respuesta esperada",
			challenge: "Reto digital",
			placeholder_team: "Equipo..",
		
			template_tooltip: "Selecciona la plantilla base cuyo contenido y configuración se copiarán en la nueva actividad.",
			must_tooltip: "Obliga a completar este reto en el orden de la ruta.",
			first_tooltip: "Hace que este reto aparezca al principio de la experiencia.",
			password_tooltip: "Código que permite desbloquear o validar el acceso al reto.",
			time_tooltip: "Tiempo disponible para completar el reto, en segundos. Es informativo, al terminar el tiempo no se cierra el reto.",
			challenge_close_time_tooltip: "Segundos mínimos antes de poder pulsar Continuar y cerrar la prueba.",
			max_points_tooltip: "Puntuación máxima que puede conseguirse al completar el reto.",
		},
		tapas: {
			tapas_settings: "Templates",
			tapas_setting: "Configuración Tapas",
			change_time: "Modificar tiempo",
			tapas_challenges: "Retos culinarios",
			tapas_challenge: "Reto culinario",
			ingredients: "Ingredientes",
			ingredient: "Ingrediente",
			item_shop: "Tienda",
			item_shop_item: "Tienda",
			name: "Nombre",
			type: "Tipo",
			quiz: "Cuestionario",
			challenge: "Reto",
			type_challenge: "Tipo de reto",
			id_name: "Nombre identificativo",
			money: "Dinero",
			template: "Plantilla",
			image: "Imagen",
			description: "Descripción",
			placeholder_type: "Selecciona un tipo",
			alert_type: "Selecciona un tipo de reto",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			placeholder_name: "Nombre del reto...",
			placeholder_description: "Descripción del reto...",
			setting: "Configuración",
			main_ingredient: "Ingrediente principal",
			secondary_ingredient: "Ingrediente secundario",
			decoration: "Decoración",
			base: "base",
			quantity: "Cantidad",
			quantity_placeholder: "Cantidad, Ej: 1 paquete 200gr...",
			objects_per_team: "Unidades por equipo",
			once_per_team: "Solo una compra por equipo",
			object_shop: "Objeto Tienda",
			challenge_shop: "Reto Tienda",
		
			quantity_tooltip: "Cantidad o formato de entrega del ingrediente, por ejemplo «1 paquete de 200 g».",
			objects_per_team_tooltip: "Define cuántas unidades se calculan de stock base en relación con el número de equipos.",
			once_per_team_tooltip: "Limita el artículo a una sola compra por equipo.",
		},
		utq: {
			challenges_utq: "Rally challenges",
			name: "Nombre",
			placeholder_name: "Nombre del reto...",
			id_name: "Nombre identificativo",
			material: "Material",
			placeholder_material: "Material...",
			description: "Descripción",
			placeholder_description: "Descripción del  reto...",
			description_score: "Descripción Puntuación",
			placeholder_description_score: "Decripcion de la puntuación del reto...",
			image: "Imagen",
			quiz: "Cuestionario",
			challenge: "Rally challenge",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			placeholder_descriptVideoinitial_challengesion_score: "Descripción de la puntuación del desafío...",
		
			material_tooltip: "Lista de materiales necesarios para preparar y ejecutar el reto.",
			description_score_tooltip: "Explica cómo debe evaluarse y puntuarse el reto.",
		},
		action: {
			action_settings: "Configuraciones",
			action_setting: "Configuración",
			quiz: "Retos de dinero",
			category_quiz: "Categorías de retos de dinero",
			category_quiz_item: "Categorías de retos de dinero",
			challenge: "Reto",
			challenge_item: "Reto",
			challenges: "Retos",
			name: "Nombre",
			category: "Categoria",
			type: "Tipo",
			setting: "Plantilla",
			init_challenge: "Reto inicial",
			init_challenges: "Retos inicales y de tienda",
			order: "Ordenación",
			match: "Emparejamiento",
			quiz_multi: "Cuestionario multirespuesta",
			text_auto: "Respuesta autocorregida",
			text_data: "Texto para corrección manual",
			text_data_auto: "Texto para corrección automática",
			type_challenge: "Tipo de reto",
			placeholder_type: "Selecciona un tipo",
			alert_type: "Selecciona un tipo de reto",
			id_name: "Nombre identificativo",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			placeholder_name: "Nombre del reto...",
			description: "Descripción",
			placeholder_description: "Descripción del reto...",
			image_quiz: "Imagen cuestionario",
			max_money: "Dinero maximo",
			need_material: "Necesita Material",
			material: "Material",
			placeholder_material: "Material necesario...",
			expected_answer: "Respuesta Esperada",
			placeholder_expected_answer: "Respuesta esperada",
			file_1: "File 1",
			file_2: "File 2",
			action_challenge_quiz: "Cuestionario",
			photo: "Foto",
			video: "Video",
			team_photo: "Foto equipo",
			template: "Plantilla",
			max_points: "Puntuación máxima",
			cost: "Coste",
			video_duration: "Video duration",
			short_description: "Descripción corta",
			placeholder_short_description: "Descripción corta...",
			help_gm: "Ayuda para puntuar",
			help_file: "Imagen Solución",
			internal_description: "Descripción interna",
			placeholder_internal_description: "Descripción del reto interno...",
			object_shop: "Tienda construcción",
			object_shop_item: "Tienda construcción",
			challenge_shop: "Retos de contrucción",
			challenge_shop_item: "Challenge Shop",
		
			max_money_tooltip: "Cantidad máxima de dinero del juego que puede obtenerse.",
		},
		actionChallengeShopItem: {
			one_per_team: "Uno por equipo",
			two_per_team: "Dos por equipo",
			one_per_two_teams: "Uno cada dos equipos",
			one_per_three_teams: "Uno para tres equipos",
			identifying_name: "Nombre Identificativo",
			identifying_name_placeholder: "Nombre identificador del cuestionario...",
			identifying_name_alert: "Pon un nombre identificativo al cuestionario.",
			image: "Imagen",
			cost: "Coste",
			max_per_team: "Máximo por equipo",
			template: "Plantilla",
			default_material: "Material por defecto",
			material_description: "Descripción del material",
			name: "Nombre",
			name_placeholder: "Nombre del reto...",
			description: "Descripción",
			description_placeholder: "Descripción del reto...",
		
			max_per_team_tooltip: "Número máximo de unidades que puede comprar cada equipo.",
			default_material_tooltip: "Define cuántas unidades se calculan de stock base en relación con el número de equipos.",
		},
		bingo: {
			image_challenge_1: "Imagen de reto 1",
			image_challenge_2: "Imagen de reto 2",
			image_post_1: "Imagen de post 1",
			image_post_2: "Imagen de post 2",
			challenge_song: "Canción de reto",
			winning_song: "Canción de ganador",
			bingo_challenges: "Retos Bingo Musical",
			bingo_challenge: "Reto Bingo Musical",
			bingo_songs: "Canciones",
			bingo_song: "Canción",
			bingo_sets: "Set",
			quiz: "Cuestionario",
			poll: "Encuesta",
			two_vs_two: "2 vs 2",
			challenge_type: "Tipo de reto",
			set: "Set",
			one_vs_all: "1 vs todos",
			image: "Imagen",
			fill: "Rellenar",
			photo: "Foto",
			song_image: "Imagen de la cancion",
			set_image: "Imagen del set",
			song_file: "Archivo de la cancion",
			challenge: "Retos ( se jugaran en orden ) ",
			song_artist: "Artista",
			song_artist_placeholder: "Artista de la cancion...",
		
			challenge_song_tooltip: "Audio utilizado para introducir o acompañar los retos.",
			winning_song_tooltip: "Audio que se reproducirá cuando haya un ganador.",
		},
		common_sense: {
			challenges: "Retos Common Sense",
			challenge: "Reto Common Sense",
			name: "Nombre",
			settings: "Plantillas Common Sense",
			setting: "Plantilla Common Sense",
			id_name: "Nombre identificativo",
			name_placeholder: "Nombre...",
			name_alert: "Añade un nombre.",
			primary_color: "Color principal",
			personalization: "Personalización",
			theme: "Tema",
			challenges_title: "Challenges",
			client_personalization: "Personalización cliente",
			font_family: "Fuente",
			client_language: "Idioma del cliente",
			background_image: "Imagen de fondo",
			event_logo: "Logo del evento",
			theme_editable: "Tema editable",
			questions_editable: "Preguntas editables",
			questions_choose: "Preguntas seleccionables",
			flow_mode_enabled: "Flow activado por defecto",
			flow_order: "Orden por defecto del Flow",
			flow_order_hint: "Selecciona primero los retos de la plantilla y después arrástralos aquí para definir el orden por defecto.",
			challenge_type: "Tipo de reto",
			challenge_type_alert: "Selecciona un tipo de reto.",
			time_results: "Tiempo de resultados",
			questions: "Preguntas",
			quiz: "Quiz",
			fair_prize: "Precio justo",
			timeline: "Timeline",
			questions_editor: {
				questions_count: "{type} · {count} preguntas",
				apply_time_to_all: "Aplicar tiempo a todas",
				add_question: "Añadir pregunta",
				no_questions_readonly: "Este reto no tiene preguntas.",
				no_questions_empty: "Añade la primera pregunta de este reto Common Sense.",
				question_label: "Pregunta",
				answers_title: "Respuestas (la primera es la correcta)",
				add_answer: "Añadir respuesta",
				correct_answer_placeholder: "Respuesta correcta",
				incorrect_answer_placeholder: "Respuesta incorrecta {n}",
				fair_prize_correct_answer: "Respuesta correcta",
				min_slider: "Mínimo del slider",
				max_slider: "Máximo del slider",
				interval: "Intervalo",
				order_hint_start: "Indicación de orden (inicio — izquierda / primero)",
				order_hint_end: "Indicación de orden (fin — derecha / último)",
				order_hint_start_placeholder: "ej. Más antiguo, Arriba, Primero",
				order_hint_end_placeholder: "ej. Más reciente, Abajo, Último",
				order_hint_help:
					"Se muestra a los jugadores en cada extremo de la línea temporal para saber cómo ordenar (ej. antiguo → nuevo o arriba → abajo).",
				correct_order: "Orden correcto",
				add_item: "Añadir elemento",
				timeline_item_placeholder: "Elemento {n}",
				image: "Imagen",
				image_optional: "Imagen (opcional)",
				question_image: "Imagen de la pregunta",
				upload_image: "Subir imagen",
				remove: "Quitar",
				question_header: "Pregunta {n}",
				question_added: "Pregunta añadida",
				time_updated: "Tiempo actualizado",
			},
		}
	},
	settings: {
		settings: "Plantillas",
		settings_list: "Lista de plantillas",
		ipad: {
			name: "Nombre",
			id_name: "Nombre identificativo",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			main_color: "Color principal",
			secondary_color: "Color secundario",
			stopwatch_color: "Color cronómetro",
			background_image: "Imagen de fondo",
			event_logo: "Logo del evento",
			points_icon: "Icono de puntos",
			challenges: "Retos",
			challenge: "Plantilla",
		
			main_color_tooltip: "Color principal utilizado en la interfaz de la plantilla.",
			secondary_color_tooltip: "Color secundario utilizado para resaltar elementos de la interfaz.",
			stopwatch_color_tooltip: "Color utilizado para mostrar el temporizador de la actividad.",
			background_image_tooltip: "Imagen de fondo que se aplicará a las pantallas de los retos.",
			points_icon_tooltip: "Icono que representará los puntos obtenidos durante el juego.",
			challenges_tooltip: "Selecciona los retos que estarán disponibles en esta plantilla.",
		},
		tapas: {
			name: "Nombre",
			id_name: "Nombre identificativo",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			secondary: "Secundarios",
			decoration: "Decoración",
			processing_time: "Tiempo de elaboración",
			ingredients: "Ingredientes",
			item_shop: "Tienda",
			tapas_challenges: "Retos culinarios",
			keyword: "Plato",
			setting: "Plantilla",
			error_secondary_ingredients: "Si hay ingredientes secundarios, debes seleccionar al menos un ingrediente principal y uno secundario",
			error_missing_main_ingredient: "Falta al menos un ingrediente principal en la plantilla",
			error_missing_secondary_ingredient: "Falta al menos un ingrediente secundario en la plantilla",
			error_missing_main_and_secondary: "Faltan ingredientes principales y secundarios en la plantilla",
		
			secondary_tooltip: "Define cuántos ingredientes secundarios aparecen en la selección de ingredientes. Simepre hay 1 ingrediente principal asignado aleatoriamente.",
			ingredients_tooltip: "Selecciona los ingredientes disponibles en la fase selección de ingrediente.",
			item_shop_tooltip: "Selecciona los artículos que estarán disponibles en la tienda del juego.",
			keyword_tooltip: "Plato que se cocina en esta plantilla.",
		},
		action: {
			name: "Nombre",
			id_name: "Nombre identificativo",
			placeholder_name_id: "Nombre identificador del reto...",
			alert_name_id: "Pon un nombre identificativo al reto.",
			challenges: "Retos",
			initial_shop_challenges: "Retos inicales y de tienda",
			categories: "Categorías de retos de dinero",
			challenge: "Plantilla",
			shop: "Tienda",
			construction_challenges: "Retos de contrucción",
			game_mode: "Modo de juego",
			menu_items: "Elementos de menú",
			initial_challenges: "Retos iniciales",
			quiz: "Retos de dinero",
			store_mode: "Construccion",
			contest_mode: "Concurso",
			menu_points: "Puntos del menú",
		
			game_mode_tooltip: "Elige si la plantilla se utilizará en Contest App o Construction App; los campos dependientes cambiarán.",
			menu_items_tooltip: "Selecciona las secciones que aparecerán en el menú de la actividad.",
		},
		cluedo_ai: {
			primary_color: "Color principal",
			secondary_color: "Color secundario",
			timer_color: "Color cronómetro",
			points_icon: "Icono de puntos",
			name: "Nombre",
			placeholder_name: "Nombre del reto...",
			id_name: "Nombre identificativo",
			image: "Imagen",
			description: "Descripción",
			placeholder_description: "Descripción del reto...",
			acts: "Casos (El orden en el que se añaden sera en el que apareceran)",
			settings: "Configuraciónes",
			setting: "Configuración"
		}
	},
	erp_settings: {
		exclude_web: "Excluir de web",
		category: "Categorías",
		main_category: "Categoría principal",
		sub_category: "Categoría secundaria",
		create_sub_category: "Nueva categoría",
		event_service: "Servicios de evento",
		fixed: "Fijo",
		add_price: "Añadir precio",
		location: "Ubicación",
		link_location: "Link de la ubicación",
		placeholder_location: "Ubicación del servicio de evento",
		placeholder_link_location: "Link de la ubicación del servicio de evento",
		event_service_name: "Nombre del servicio de evento",
		placeholder_event_service_name: "Nombre del servicio de evento",
		new_event_service: "Nuevo Servicio de evento",
		link_app: "Link App",
		youtube_url: "URL de YouTube",
		placeholder_youtube_url: "URL del video de YouTube",
		organization: "Organización",
		name: "Nombre",
		placeholder_name: "Nombre",
		alert_name: "Debe tener un nombre",
		logo: "Logo",
		default_image: "Imagen predeterminada",
		color_primary_document: "Color principal de documentos",
		color_secondary_document: "Color secundario de documentos",
		billing: "Facturación",
		placeholder_billing: "Datos de facturación...",
		billing_mail: "Email de facturación",
		placeholder_billing_mail: "email@empresa.com",
		holded_contact_id: "ID contacto Holded",
		placeholder_holded_contact_id: "ID del contacto en Holded",
		vat_type: "Tipo de IVA",
		vat_type_21: "21%",
		vat_type_exempt: "Exento",
		gm_info_text: "Aviso para monitores / instructores",
		placeholder_gm_info_text: "Texto que verán los monitores al abrir una reserva...",
		list_activities: "Lista de Actividades",
		new_activity: "Nueva Actividad",
		search: "Buscar",
		placeholder_search: "Buscar por nombre",
		in_person: "presencial",
		online: "Online",
		modality: "Modalidad",
		alert_modality: "Selecciona una modalidad",
		general_media: "Media",
		pricing_list: "Lista de precios",
		activity_name: "Nombre",
		placeholder_activity_name: "Nombre de la actividad (Cliente)",
		duration: "Duración",
		placeholder_duration: "Duracion de la actividad",
		description: "Descripción",
		placeholder_description: "Descipcion de la actividad",
		requirements: "Requerimientos",
		placeholder_requirements: "Requirimentos de la actividad",
		includes: "Incluye",
		placeholder_includes: "Que incluye la actividad",
		dynamic: "Dinámica",
		placeholder_dynamic: "Dinámica de la actividad",
		budget_description: "Descripción del presupuesto",
		placeholder_budget_description: "Descripción del presupuesto",
		media: "Media en este idioma",
		extras: "Extras",
		price: "Precio",
		activity: "Actividad",
		type_price: "Tipo de precio",
		alert_type_price: "Seleciona un tipo de precio",
		new_extra: "Nuevo Extra",
		preview_pdf: "Previsualizar PDF",
		staff_document: "Documento para staff",
		extra_deleted: "Se ha eliminado el extra",
		extra_not_deleted: "No se ha eliminado el extra",
		placeholder_name_extra: "Nombre del extra",
		placeholder_description_extra: "Descripción del extra",
		extra: "Extra",
		total: "Total",
		by_person: "Por Persona",
		final_page_budget: "Página final de presupuesto",
		new_final_page_budget: "Nueva página final de presupuesto",
		final_page_budget_deleted: "Se ha eliminado la página final de presupuesto",
		final_page_budget_not_deleted: "No se ha podido eliminar la página final de presupuesto",
		placeholder_description_activity: "Descripcion de la actividad",
		question: "Pregunta",
		placeholder_question: "Pregunta",
		all_activities: "Todas las actividades",
		no_activity: "Sin actividad",
		placeholder_activity: "Filtrar por actividad",
		questions_activities: "Preguntas sobre actividades",
		code: "Código",
		placeholder_code: "Codigo de la actividad",
		question_booking: "Preguntas sobre reservas",
		new_question_booking: "Nueva pregunta sobre reservas"
	},
	previews: {
		menu: "Menu"
	},
	login: {
		description: "Aplicación de {company} para la realización de eventos de Team Building",
		email: "Email",
		placeholder_email: "Entra tu email",
		password: "Contraseña",
		placeholder_password: "At least 8 characters",
		sign_in: "Iniciar Sesión",
		invalid_credentials: "Credenciales incorrectas",
		forgor_password: "Contraseña olvidada"
	},
	formGenerator: {
		pricing: {
			new_price: "+ Nueva linea de precio",
			min_persons: "Personas minimo",
			max_persons: "Personas maximo",
			total_price: "Precio total",
			person_price: "Precio persona",
			price: "Precio "
		}
	},
	dialogs: {
		close: "Cerrar",
		sure: "Estas seguro?",
		erase: "Borrar",
		erase_record: "Borrar registro",
		delete_team: "Eliminar equipo",
		confirm_delete_team: "¿Estás seguro de que quieres eliminar el equipo",
		delete: "Eliminar",
		delete_colon: "Eliminar: ",
		cancel: "Cancelar",
		name: "Nombre",
		add: "Añadir",
		placeholder_team: "Equipo..",
		edit_team: "Editar equipo",
		save: "Guardar",
		demo_limit: "Las actividades de demo solo permiten 2 equipos",
		link_staff: "Enlace Staff",
		link_admin: "Enlace Administrador",
		link_results: "Enlace de resultados",
		go_results: "Ir a resultados",
		add_team: "Añadir equipo",
		material_recalculate: "Al crear el equipo se recalculara el material",
		material_tab_no_update_add_teams: "La pestaña de material no se actualizará si añades equipos",
		warning: "Aviso",
		add_team_money: "Añadir dinero equipo",
		link_teams: "Enlace Equipos",
		challenge_delete: "Se elminiarla el reto: ",
		create: "Crear",
		challenge: "Reto",
		item: "Artículo",
		stock: "Material",
		placeholder_challenge: "Selecciona un reto",
		warning_change_template: "Al cambiar la plantilla se borraran todas los retos",
		team: "Equipo",
		teams: "Equipos",
		points_negative: "Puntos (pueden ser negativos)",
		money_negative: "Importe (puede ser negativo)",
		minutes: "Minutos",
		seconds: "Segundos",
		substract: "Restar",
		expected_answer: "Respuesta esperada: ",
		challenge_score: "Puntuar reto",
		activate: "Activar",
		material_recalculate_delete: "Al eliminar el equipo se recalculara el material",
		add_route: "Añadir ruta",
		confirm: "Confirmar",
		accept: "Aceptar",
		activity: "Actividad",
		language: "Idioma",
		placeholder_language: "Selecciona un idioma",
		logo: "Logo",
		sure_delete_acitivty: "Estas seguro que quieres borrar al actividad?",
		add_favorite: "Añadir a favoritos",
		delete_favorite: "Quitar de favoritos",
		date: "Fecha",
		unsaved_changes_content: "Estas seguro?",
		unsaved_changes_title: "Se perderan los cambios no guardados",
		stay: "Quedarse",
		exit: "Salir",
		client_validate: "Se necesita validar datos de cliente",
		close_booking: "Cerrar reserva",
		cancel_reason: "Motivo de la cancelación",
		finish: "Finalizar",
		favorite_challenge: "Favorito",
		object: "Objeto",
		character: "Personaje",
		key_information: "Información clave",
		give: "Dar",
		key_information_done: "Información clave completada",
		give_key_information: "Dar información clave",
		team_components_precreated_only: "Los miembros del equipo solo se utilizan en partidas online, donde los usuarios seleccionan su equipo desde la página de equipos.",
		team_components: "Componentes del equipo",
		team_components_placeholder: "Añade un componente y pulsa enter"
	},
	camera: {
		title_error_modal: "Error en la cámara",
		text_error_modal: "Avisar a la persona de staff para revisar la cámara. Error: ",
		btn_reload_app: "Recargar aplicación",
		btn_load_foto: "Subir foto desde la galería",
		modal_upload_title: "Subir Foto",
		modal_upload_text: "Puedes subir tu foto desde la galería",
		error_no_upload: "Tienes que subir una foto primero",
		error_upload_photo: "Error al subir la foto, vuelve a intentarlo"
	},
	chat: {
		message: "Mensaje",
		message_placeholder: "Escribe tu mensaje",
		message_btn: "Enviar mensaje",
		send: "Enviado",
		read: "Leído",
		new_message_summary: "Nuevo mensaje de chat",
		new_message_detail: "Tienes un nuevo mensaje del STAFF"
	},
	customization: {
		common_sense: {
			subtitle: "Personaliza tu experiencia Common Sense",
			not_found: "Este enlace de personalización no es válido.",
			tab_personalization: "Personalización",
			tab_create_content: "Crear contenido",
			challenges_selection: "Selección de retos",
			challenges_selection_hint: "Activa los retos que quieras usar. Puedes expandir cada uno para ver preguntas y respuestas (solo lectura).",
			challenges_view: "Retos",
			challenges_view_hint: "Vista de solo lectura. Expande cada reto para ver preguntas y respuestas.",
			read_only_notice: "Este enlace es de solo lectura. Puedes revisar el contenido pero no modificar, activar ni añadir retos.",
			no_challenges: "No hay retos configurados en esta plantilla.",
			upload_image: "Subir imagen",
			event_logo: "Logo del evento",
			event_logo_hint: "Este logo se usará en la pantalla pública del juego cuando se seleccione esta plantilla.",
			logo_saved: "Logo guardado",
			logo_save_error: "No se pudo guardar el logo",
			public_link: "Enlace de personalización cliente",
			public_link_hint: "Comparte este enlace con tu cliente. Se genera al guardar la plantilla.",
			challenges_client: "Retos seleccionados por el cliente",
			no_questions: "No hay preguntas configuradas.",
			untitled_question: "Pregunta sin título",
			untitled_step: "Paso sin título",
			correct: "correcta",
			correct_answer: "Respuesta correcta",
			select_challenge: "Selecciona un reto",
			new_challenge: "Nuevo reto",
			add_challenge: "Añadir reto",
			challenge_added: "Reto añadido",
			challenge_name_required: "Indica un nombre para el reto",
			delete_challenge: "Eliminar",
			delete_challenge_confirm_title: "¿Eliminar este reto?",
			delete_challenge_confirm_message:
				"Se eliminará «{name}» de esta plantilla. Esta acción no se puede deshacer.",
			challenge_deleted: "Reto eliminado",
			nothing_enabled: "No hay opciones de personalización habilitadas para esta plantilla.",
			client_edit: "El cliente puede editar este reto",
			autosave_saving: "Guardando…",
			autosave_saved: "Cambios guardados",
			autosave_error: "No se pudo guardar. Inténtalo de nuevo.",
			challenges_client_hint:
				"Solo puedes elegir retos que ya estén seleccionados en «Retos».",
			challenges_client_select_master_first:
				"Selecciona al menos un reto en «Retos» para poder configurar los retos del cliente.",
		},
	},
	gm: {
		modals: {
			add_monitor: "+ Añadir monitor",
			save: "Guardar",
			name: "Nombre del monitor",
			placeholder_name: "Nombre del monitor",
			saved_monitor: "Monitor guardado",
			continue: "Continuar",
			change: "Cambiar",
			exit: "Salir",
			cancel: "Cancelar",
			exit_event: "Salir del evento",
			password: "Contraseña",
			enter_name: "Introduce tu nombre"
		},
		ranking: {
			show: "Enseñar Ranking",
			hide: "Esconder Ranking"
		},
		dashboards: {
			teams: "Equipos",
			credits_to_consume: "Créditos a consumir",
			unit_cost: "coste unitario",
			links: "Enlaces",
			name: "Nombre del equipo",
			chat: "Mensajes",
			configuration: "Configuración de general",
			configuration_activity: "Configuración de actividad",
			link_ranking: "Enlace Ranking",
			link_results: "Enlace de resultados",
			link_monitors: "Enlace Monitores",
			link_admin: "Enlace Admin",
			link_presentation: "Enlace Presentación",
			link_teams: "Enlace Equipos",
			list_ingredients: "Lista de ingredientes",
			link_favorite_images: "Enlace Imagenes favoritas",
			total: "Total",
			remaining: "Restante",
			round_ends: "La ronda finaliza en",
			round: "Ronda",
			play: "Jugar",
			resume: "Continuar",
			pause: "Pausar",
			pass_round: "Saltar Ronda",
			time_ranking: "Ver tiempo en ranking",
			results: "Resultados",
			add_team: "Añadir Equipo",
			add_teams: "Añadir Equipos",
			order_points: "Ordenar ranking por puntos",
			add_challenges_first: "Añade retos primero",
			general: "General",
			material: "Material",
			event_configuration: "Configura el evento primero",
			back: "Atrás",
			save: "Guardar",
			challenges: "Retos",
			score_categories: "Categorias de puntuación",
			defense: "DEFENSA",
			presentation: "PRESENTACIÓN",
			flavor: "SABOR",
			money: "DINERO",
			round_time: "Duración en minutos",
			tapas_time: "Tiempo de cocina",
			round_time_minutes: "Tiempo por ronda en minutos",
			type: "Plantilla",
			placeholder_type: "Selecciona un tipo",
			setting_logo_replace_title: "¿Usar el logo de la plantilla?",
			setting_logo_replace_message:
				"El evento ya tiene un logo. ¿Quieres mantener el actual o usar el logo configurado por el cliente en la plantilla?",
			setting_logo_keep_event: "Mantener logo del evento",
			setting_logo_use_setting: "Usar logo de la plantilla",
			ingredient: "Ingredientes",
			shop: "Tienda",
			select_challenge: "Selecciona algun reto",
			select_activity: "Selecciona una actividad",
			select_time_round: "Pon un tiempo por ronda",
			select_time_tapas: "Pon un tiempo para realizar las tapas",
			select_categories: "Porfavor selecciona las categorias",
			team_turn: "Turno del equipo",
			type_election: "Tipo de elección",
			round_election: "Ronda de elección",
			round_total: "Ronda total",
			time_elaboration: "Tiempo de elaboración",
			name_team: "Ponle un nombre al equipo",
			number_teams: "Numero de equipos",
			total_ingredients: "Total de ingredientes",
			extra_ingredients: "Ingredientes extras",
			total_decoration: "Total decoración",
			extra_decoration: "Decoración extra",
			missing_ingredients: "Faltan ingredientes",
			list_download: "Descargar Lista",
			ingredients: "Ingredientes",
			saved: "Guardado",
			start_game: "Comenzar Juego",
			gm: "Monitor",
			monitors: "Monitores",
			monitors_visible: "Monitores visibles",
			monitors_hidden: "Monitores ocultos",
			readed: "Leido",
			sent: "Enviado",
			message_team: "Escribe un mensaje al equipo ",
			message_all_teams: "Los mensajes que escribas se enviarán a todos los equipos",
			your_message: "Tu mensaje",
			upload_image: "Subir imagen",
			add_emoji: "Añadir emoticono",
			send_message: "Enviar mensaje",
			all: "Todos los equipos",
			challenge: "Reto",
			id_name: "Nombre identificativo",
			latitude: "Latitud",
			longitude: "Longitud",
			activations_radius: "Radio de activación",
			categories_points: "Categorias de puntuación",
			must_upper: "OBLIGATORIO",
			first_upper: "PRIMERO",
			type_activation: "Tipo de activación",
			qr_upper: "QR",
			qr_code: "Código QR",
			location_upper: "UBICACIÓN",
			first: "Primera",
			must: "Obligatoria",
			add_challenges: "Añade retos",
			select_latitude: "Selecciona una latitud",
			select_longitude: "Selecciona una longitud",
			placeholder_id_name: "Pon un nombre identificativo",
			placeholder_template: "Selecciona una plantilla",
			put_duration: "Pon una duración",
			initial_position: "Posición inicial",
			not_template: "Sin plantilla",
			template: "Plantilla",
			placeholder_search_address: "Busca una dirección...",
			drag_drop_image: "Arrastra y suelta una imagen aquí",
			or_click_upload: "o haz clic para subir",
			no_image: "No hay imagen disponible",
			duration_seconds: "Duración (minutos)",
			duration_hours: "Duración en horas",
			duration_minutes: "Duración en minutos",
			categories: "Categorías de retos de dinero",
			time_action: "Pon un tiempo para realizar los retos",
			routes: "Rutas",
			team_no_route: "Hay equipos sin ruta",
			changes_not_saved: "Cambios no guardados",
			route: "Ruta",
			order: "Orden: ",
			name_route: "Nombre",
			placeholder_name_route: "Nombre de la ruta",
			event: "Evento",
			select_setting: "Selecciona una configuración",
			initial_challenges: "Retos Iniciales",
			time_higher_zero: "El tiempo debe ser mayor que 0",
			time_required: "El tiempo por ronda es requerido",
			time_integer: "El tiempo tiene que ser un entero",
			warning_template: "Si no eliges una plantilla tendras que crear todos los retos manualmente.",
			add_teams_first: "Antes de añadir material tienes que añadir equipos",
			acts: "Casos",
			placeholder_acts: "Selecciona un caso",
			qr_codes: "Códigos QR",
			objects: "Objetos",
			characters: "Personajes",
			type_game: "Tipo de juego",
			team_mode: "Configuración de equipos",
			alert_team_mode: "Selecciona una configuración de equipos",
			team_mode_on_the_fly: "Equipos al vuelo",
			team_mode_on_the_fly_desc:
				"Los jugadores entran primero al lobby y los equipos se crean después. Este modo podrá funcionar con ubicaciones (para agrupar o identificar jugadores por mesa, sala, ciudad, sede, etc.) o sin ubicaciones (todos los jugadores entran y luego se crean los equipos).",
			team_mode_precreated: "Equipos prerealizados",
			team_mode_precreated_desc:
				"Utiliza el sistema actual de Teaming App, donde los equipos ya están creados previamente antes de iniciar la partida.",
			map_configuration: "Configuración del mapa",
			finish_latitude: "Latitud final",
			finish_longitude: "Longitud final",
			map: "Mapa",
			init: "Inicio",
			finish: "Fin",
			online: "Online",
			presential: "Presencial",
			hybrid: "Híbrido",
			game_image: "Subir la foto que verán los jugadores en su app",
			sets: "Sets",
		
			finish_position: "Posición final",
			template_tooltip: "Selecciona la plantilla base cuyo contenido y configuración se copiarán en la nueva actividad.",
			presential_tooltip: "Utiliza esta opción cuando participantes y monitores estén en el mismo espacio. La música se reproduce en la pantalla pública.",
			online_tooltip: "Utiliza esta opción cuando los participantes se conecten a distancia. La música se reproduce en la vista del jugador.",
			type_game_tooltip: "Define cómo se desbloquean los retos: QR requiere escanear códigos y no necesita configurar un mapa; Map utiliza ubicaciones y geolocalización para activarlos por proximidad.",
			online_mode_tooltip: "La investigación se realiza sin ubicaciones físicas ni códigos QR. Los personajes y objetos empiezan desbloqueados.",
			qr_upper_tooltip: "Los equipos desbloquean las pruebas escaneando códigos QR. No es necesario configurar un mapa.",
			map_tooltip: "Los equipos utilizan el mapa y la geolocalización para encontrar las pruebas.",
			initial_position_tooltip: "Define el punto de referencia alrededor del que se situarán inicialmente todas las pruebas. También se establece como punto final de la actividad, aunque después puede modificarse.",
			finish_position_tooltip: "Se establece como punto final de la actividad, aunque después puede modificarse.",
			all_teams: "Todos los equipos",
		},
		utq: {
			change_monitor: "Cambiar Monitor",
			round: "Ronda",
			ends: "Finaliza",
			start: "Iniciar juego",
			team_upper: "Equipo",
			position_upper: "Posición",
			points_upper: "Puntos",
			team: "Equipo",
			placeholder_team: "Selecciona un equipo",
			score: "Puntuación",
			rate: "Puntuar",
			instructions_material: "Instrucciones y material",
			name_event: "Pon un nombre al evento",
			select_team: "Selecciona un equipo",
			operation: "Funcionamiento",
			material: "Material"
		},
		tapas: {
			disponible_later: "Disponible más adelante",
			round_ends: "La ronda finaliza en",
			score_missing: "Quedan retos sin puntuar a los equipos",
			start_challenges: "Iniciar retos",
			start_selection: "Empezar Selección Ingredientes",
			start_elaboration: "Empezar Tiempo de Elaboración",
			pass_round: "Saltar Ronda",
			selecting_ingredients: "Seleccionando ingredientes",
			pass_selection: "Saltar selección",
			team_turn: "Turno del equipo",
			type_selection: "Tipo de selección",
			round_selection: "Ronda de selección",
			round_total: "Ronda total",
			votes: "Votaciones",
			type_choice: "Tipo de elección",
			top_1: "Top 1",
			top_2: "Top 2",
			top_3: "Top 3",
			round: "Ronda",
			time_eleboration: "Tiempo de elaboración",
			start: "Iniciar juego",
			challenges: "Retos",
			placeholder_challenge: "Selecciona un reto y pulsa empezar",
			orders: "Pedidos",
			change_money: "Modificar dinero",
			shop: "Tienda",
			challenges_results: "Resultados retos",
			ingredient_selection: "Selección de ingredientes",
			winners: "Ganadores",
			placeholder_select_team: "Selecciona un equipo",
			category: "Categoria",
			rate: "Puntuar",
			defense: "Defensa",
			show: "Presentación",
			flavour: "Sabor",
			change_main_ingredient: "Cambiar Ingrediente Principal",
			challenges_done: "Retos realizados"
		},
		ipad: {
			time_game: "Tiempo de juego",
			start_game: "Comenzar Juego",
			add_delete_time: "Añadir/Quitar Tiempo",
			hide_ranking: "Esconder Ranking",
			show_ranking: "Enseñar Ranking",
			lock_challenges: "Bloquear Retos",
			unlock_challenges: "Desbloquear Retos",
			move_challenges: "Mover pruebas",
			challenges: "Retos",
			clean_filters: "Borrar filtros",
			add_delete_points: "Ajustar puntos",
			activate_challenge: "Activar reto",
			no_route: "Sin Ruta",
			instructor: "Monitor",
			player: "Jugador",
			team: "Equipo",
			points: "Puntos",
			challenges_done: "Retos Realizados",
			last_challenge: "Ultimo Reto",
			hour: "Hora",
			must: "Obligatorios",
			optionals: "Opcionales",
			status_not_started: "No empezado",
			status_started: "Empezado",
			status_pending: "En camino",
			status_done: "Completado",
			select_team_to_view_challenges: "Selecciona un equipo para ver sus retos"
		},
		action: {
			next_challenge: "Forzar reto",
			start: "Iniciar juego",
			next: "Siguiente",
			time_game: "Tiempo de juego",
			start_game: "Comenzar Juego",
			add_delete_time: "Añadir/Quitar Tiempo",
			ranking: "Ranking",
			finish_game: "Finalizar Juego",
			reactivate_game: "Reactivar Juego",
			challenges: "Retos",
			clean_filters: "Borrar filtros",
			team_filter: "Filtro Equipo",
			challenge_filter: "Filtro Reto",
			add_delete_points: "Ajustar puntos",
			add_delete_money: "Ajustar dinero",
			activate_quiz: "Activar Cuestionario",
			ranking_normal: "Normal",
			ranking_coop: "Cooperativo",
			ranking_both: "Ambos",
			ranking_hidden: "Escondido",
			ranking_slides: "Diapositivas",
			activate_challenge: "Activar reto",
			show_videos: "Imagenes Finales",
			select_action: "Estado",
			quizzes: "Cuestionarios",
			challenge_not_start: "Todavia no ha comenzado ningun reto",
			challenges_pick: "Retos a recoger",
			challenges_return: "Retos a devolver",
			challenges_material: "Material retos",
			update_stock: "Modificar Stock",
			update_initial_stock: "Modificar stock inicial",
			picked_challenges: "Retos Recogidos",
			fake_upload: "Subida Falsa",
			no_picked_challenges: "No hay retos recogidos disponibles",
			stock_upper: "STOCK: ",
			stock_initial_upper: "STOCK INICIAL: 2",
			stock: "Stock",
			team_upper: "Equipo",
			challenge_upper: "RETO",
			returned_upper: "DEVUELTO",
			delivered_upper: "ENTREGADO",
			team: "Equipo",
			points: "Puntos",
			money: "Dinero",
			quizzes_done: "Cuestionarios Realizados",
			challenges_done: "Retos Realizados",
			last_challenge: "Ultimo Reto",
			material: "Material",
			save: "Guardar",
			material_to_pick: "Material a recoger",
			stock_shop: "Stock de la tienda",
			delivery: "Entregado",
			challenge_started: "Reto iniciado",
			error_start_challenge: "Error al iniciar el reto",
			challenge_flash: "Reto Flash",
			add_favorite: "Añadir a favoritos",
			delete_favorite: "Eliminar de favoritos",
		
			ranking_slides_tooltip: "Imágenes que se pueden mostrar en la pantalla del ranking par explciar o empezar el juego.",
			stock_tooltip: "Número de unidades disponibles para comprar por defecto.",
		},
		cluedo_ai: {
			pause_game: "Pausar Juego",
			resume_game: "Reanudar Juego",
			no_chat: "No hay chat",
			game_done: "Juego finalizado. Dirígete al punto de encuentro final.",
			act_information: "Información del caso",
			characters: "Personajes",
			objects: "Objetos",
			key_informations: "Información clave",
			chat: "Mensajes",
			ranking: "Ranking",
			configuration: "Opciones",
			start_game: "Comenzar Juego",
			next_act: "Siguiente Caso",
			add_points: "Añadir Puntos",
			add_time: "Añadir Tiempo",
			give_object: "Dar Objeto",
			give_information: "Dar Información",
			questions: "Preguntas",
			team: "Equipo",
			points: "Puntos",
			objects_found: "Objetos encontrados",
			characters_found: "Personajes encontrados",
			questions_answered: "Preguntas respondidas",
			position: "Posición",
			add_delete_time: "Añadir/Quitar Tiempo",
			add_delete_points: "Ajustar puntos",
			participants_answer: "Respuesta participantes",
			correct_answer: "Respuesta correcta",
			score: "Puntuación",
			feedback: "Feedback",
			not_evaluated: "Sin evaluar",
			edit_question: "Editar pregunta",
			last_act: "Último caso",
			evaluated: "Evaluado",
			confirm_start_game: "¿Seguro que quieres empezar el juego?",
			confirm_next_act: "¿Seguro que quieres pasar al siguiente caso?",
			confirm_last_act: "¿Seguro que quieres finalizar el último caso?",
		
			character_name_alt: "Nombre del sospechoso",
			object_name_alt: "Nombre del objeto",
		},
		collabo: {
			player_answer: "Respuesta del jugador",
			double_materials_mode: "Modo de Materiales Duplicados",
			material_multiplier_title: "Multiplicador de materiales",
			material_multiplier_configure: "Configurar multiplicador",
			material_multiplier_next_distribution: "Se aplicará al próximo reparto de materiales.",
			material_multiplier_updated: "Multiplicador de materiales actualizado correctamente",
			material_multiplier_x1_hint: "Ideal para más de 30 pax",
			material_multiplier_x2_hint: "Ideal para 20 a 30 pax",
			material_multiplier_x3_hint: "Ideal de 10 a 20 pax",
			material_multiplier_x4_hint: "Menos de 10 pax",
			double_materials_mode_on: "Activado",
			double_materials_mode_off: "Desactivado",
			stage_give_material: "Dar Material",
			select_team: "Seleccionar Equipo",
			select_material: "Seleccionar Material",
			enter_quantity: "Introducir Cantidad",
			quantity_by_team: "Cantidad por equipo",
			enter_quantity_by_team: "Introducir cantidad por equipo",
			give_material: "Dar Material",
			material_given_success: "Material dado correctamente",
			material_given_error: "Error al dar el material",
			material: "Material",
			double_materials_mode_updated: "Modo de Materiales Duplicados actualizado correctamente",
			quantity: "Cantidad",
			controls: "Controles",
			total_teams: "Total de equipos",
			total_rounds: "Total de rondas",
			start_final_construction_round: "Iniciar ronda final de construcción",
			final_construction_round_started: "Ronda final de construcción iniciada",
			undo_final_construction_round: "Deshacer ronda final de construcción",
			confirm_start_final_construction_round: "¿Seguro que quieres cambiar al modo final de construcción?",
			confirm_undo_final_construction_round: "¿Seguro que quieres deshacer el modo final de construcción?",
			final_construction_round_undone: "Ronda final de construcción deshecha",
			teams_list: "Lista de equipos",
			start_game: "Iniciar juego",
			no_teams: "No hay equipos",
			game_started: "Juego iniciado correctamente",
			game_start_error: "Error al iniciar el juego",
			challenges_status: "Estado de Retos",
			confirmed_teams: "Equipos Confirmados",
			total_points: "Puntos Totales",
			correct_answer: "Respuesta Correcta",
			solution: "Solución",
			players_response: "Respuesta de los equipos",
			team_removed_from_challenge: "Equipo eliminado del reto",
			team_remove_from_challenge_error: "Error al eliminar equipo del reto",
			construction_phase_started: "Fase de construcción iniciada",
			construction_phase_error: "Error al iniciar fase de construcción",
			construction_phase: "Fase de Construcción",
			constructions_in_progress: "Construcciones En Progreso",
			no_constructions_in_progress: "No hay construcciones en progreso",
			building_type: "Tipo de Construcción",
			leading_team: "Equipo Líder",
			helping_teams: "Equipos Ayudantes",
			completed_constructions: "Construcciones Completadas",
			no_completed_constructions: "No hay construcciones completadas",
			view_all_constructions: "Ver todas",
			all_completed_constructions: "Todas las construcciones completadas",
			all_constructions_ordered_by_last_done: "Lista ordenada por la construcción más reciente primero.",
			constructions_of_type_ordered_by_last_done: "Todas las construcciones de este tipo, ordenadas por la más reciente primero.",
			order: "#",
			remaining_materials: "Materiales Restantes",
			construction_phase_finished: "Fase de construcción finalizada",
			construction_phase_finish_error: "Error al finalizar fase de construcción",
			team: "Equipo",
			position: "Posición",
			points: "Puntos",
			chat: "Mensajes",
			ranking: "Ranking",
			configuration: "Opciones",
			go_to_construction: "Ir a Fase de Construcción",
			finish_construction_phase: "Finalizar Fase de Construcción",
			show_teams: "Mostrar Equipos",
			hide_teams: "Ocultar Equipos",
			unsaved_changes: "Tienes cambios sin guardar",
			save: "Guardar",
			number_of_challenges: "Sets de retos",
			link_teams: "Enlazar Equipos",
			link_monitors: "Enlazar Monitores",
			link_staff: "Enlace Staff",
			add_team: "Añadir Equipo",
			add_teams: "Añadir Equipos",
			materials: "Materiales",
			no_materials: "No hay materiales",
			constructions: "Construcciones",
			no_constructions: "No hay construcciones",
			challenges: "Retos de materiales",
			no_challenges: "No hay retos",
			round_time: "Tiempo de ronda de retos en minutos",
			minutes: "Minutos",
			round_time_placeholder: "Introduce el tiempo de ronda en minutos",
			challenge_time: "Tiempo de ronda de construcción en minutos",
			challenge_time_placeholder: "Introduce el tiempo de construccion en minutos",
			game_mode: "Modo de Juego",
			teams: "Equipos",
			individual: "Individual",
			ranking_title: "Título de la ciudad",
			ranking_title_placeholder: "Título mostrado en la pantalla pública del ranking",
			total: "Total",
		
			ranking_title_tooltip: "Título que se mostrará en la pantalla pública del ranking.",
			individual_tooltip: "Cada participante juega desde su propio móvil y accede a la actividad mediante un código QR.",
			teams_tooltip: "Los participantes juegan en equipos fijos y comparten una tablet durante toda la actividad.",
			number_of_challenges_tooltip: "Define cuántos juegos completos de retos se usará. Para eventos de más de 50 participantes.",
		},
		common_sense: {
			controls: "Controles",
			total_teams: "Total de equipos",
			no_teams: "No hay equipos",
			start_game: "Iniciar juego",
			pause_game: "Pausar Juego",
			resume_game: "Reanudar Juego",
			show_final_ranking: "Mostrar ranking final",
			game_final_ranking: "Ranking final",
			game_status_final_ranking: "Ranking final",
			final_ranking_shown: "Ranking final mostrado",
			game_resumed: "Juego reanudado",
			game_running: "Juego en curso",
			game_paused: "Juego en pausa",
			teams_list: "Lista de equipos",
			game_started: "Juego iniciado correctamente",
			game_start_error: "Error al iniciar el juego",
			ranking: "Ranking",
			challenge_ranking: "Ranking del reto",
			ranking_your_team: "Tu equipo",
			ranking_leaderboard: "Clasificación",
			ranking_points_abbr: "pts",
			ranking_number_header: "N.º",
			team: "Equipo",
			position: "Posición",
			points: "Puntos",
			phase: "Fase",
			roulette: "Ruleta",
			roulette_stage_title: "Desafíos de la ruleta de equipo",
			select_challenge: "Selecciona un reto",
			challenge_started_times: "({count}×)",
			roulette_start: "Empezar",
			public_rules_show: "Mostrar normas en la pantalla pública",
			public_rules_hide: "Ocultar normas en la pantalla pública",
			roulette_hint: "Selecciona un reto y empieza la ruleta.",
			flow_mode: "Modo Flow",
			flow_mode_hint: "Ordena los retos y guarda para que el instructor solo tenga que pulsar Siguiente.",
			flow_instructor_hint: "Activa el Flow para avanzar con Siguiente. Puedes ajustar el orden y los boosters antes de continuar si necesitas hacer cambios de última hora.",
			flow_event_hint: "Define el orden del flow para este evento. Podrás cambiarlo en vivo si hace falta.",
			flow_remove_challenge: "Quitar reto del flow",
			flow_restore_all: "Restaurar todos",
			flow_restore_selected: "Usar retos seleccionados",
			flow_position: "Posición",
			flow_no_booster: "Sin booster",
			flow_configure: "Configurar Flow",
			flow_enabled: "Flow activo",
			flow_disabled: "Flow inactivo",
			flow_challenge_progress: "Juego {current} de {total}",
			skip_flow_challenge: "Saltar reto",
			skip_flow_challenge_confirm:
				"¿Seguro que quieres saltar este reto? Si está en curso pasará a la pantalla principal; si aún no ha empezado se omitirá del flow sin mostrarse a los jugadores.",
			skip_flow_challenge_done: "Reto saltado",
			next: "Siguiente",
			advance_phase: "Avanzar fase",
			finish_challenge: "Finalizar reto",
			finish_ranking: "Finalizar ranking",
			reset_to_waiting_challenge: "Volver a elegir reto",
			reset_to_waiting_challenge_confirm:
				"Volverás a la fase de espera (ruleta) sin mostrar el ranking del reto ni completar las rondas pendientes. Los puntos ya asignados en rondas anteriores se mantienen.",
			reset_to_waiting_challenge_done: "Fase reiniciada: puedes elegir un nuevo reto",
			add_substract_points: "Sumar / restar puntos",
			points_hint: "Usa valores negativos para restar.",
			boosters: "Boosters",
			booster_half_time: "Mitad de tiempo",
			booster_points_x2: "Puntos x2",
			select_booster: "Selecciona un booster",
			apply_booster: "Aplicar booster",
			roulette_challenge_image_alt: "Imagen del reto: {name}",
			roulette_challenge_default: "Reto {id}",
			roulette_show_badge: "RETO",
			public_no_challenges: "No hay retos configurados para este evento.",
			public_loading: "Cargando…",
			public_waiting_game: "Esperando a que el anfitrión inicie el juego.",
			public_waiting_challenge: "Cuando el anfitrión saque un reto, la ruleta se reproducirá aquí.",
			player_menu_play: "Juego",
			player_menu_settings: "Ajustes",
			instructor_menu_controls: "Controles del juego",
			instructor_menu_ranking: "Ranking",
			instructor_menu_settings: "Opciones",
			ranking_team_fallback: "Equipo {id}",
			public_challenge_rules: "Normas del reto",
			public_no_rules_text: "No hay texto de normas configurado para este reto.",
			challenge_play_subphase: "Paso del reto {n}",
			in_challenge_phase_waiting: "Esperando reto",
			in_challenge_phase_rolling: "Ruleta",
			in_challenge_phase_showing_rules: "Mostrando normas",
			in_challenge_phase_playing: "Reto en juego",
			in_challenge_phase_result: "Resultado del reto",
			in_challenge_phase_ranking: "Ranking",
			in_challenge_phase_unknown: "Fase desconocida",
			challenge_subphase_progress: "{current} de {total}",
			challenge_subphase_of: "de",
			phase_code: "Fase {code}",
			challenge_no_active: "No hay ningún reto activo seleccionado.",
			challenge_fair_prize_play: "Reto de precio justo — pantalla de juego",
			challenge_quiz_play: "Reto tipo cuestionario — pantalla de juego",
			challenge_timeline_play: "Reto de línea temporal — pantalla de juego",
			timeline_no_rounds: "No hay rondas de línea temporal configuradas para este reto.",
			timeline_question_heading: "Ordena los pasos",
			timeline_order_hint: "Ordena las tarjetas. Puedes cambiar el orden hasta que termine el tiempo.",
			timeline_order_context_aria: "Cómo ordenar la línea temporal",
			timeline_position: "{n}",
			timeline_question_label: "Pregunta {n}",
			timeline_timer_aria: "Tiempo restante",
			phase_timer_question: "Tiempo",
			phase_timer_results: "Tiempo",
			timeline_steps_aria: "Pasos a ordenar",
			timeline_submit_answer: "Enviar orden",
			timeline_answer_submitted: "Orden enviada",
			timeline_result_intro: "Tu orden y los puntos de cada tarjeta.",
			timeline_result_round_label: "Puntos de esta ronda",
			timeline_result_no_movement: "No has realizado ningún movimiento.",
			timeline_result_total: "+{n} pts",
			timeline_result_points: "+{n}",
			timeline_result_correct: "Correcto",
			timeline_result_semi: "Casi",
			timeline_result_wrong: "Incorrecto",
			timeline_result_should_be: "Orden correcto: {n}",
			timeline_public_result_hint: "Orden correcto de la secuencia.",
			timeline_public_team_hits: "Aciertos de equipo: {n}",
			timeline_public_perfect_order: "Orden perfecto",
			timeline_public_perfect_score: "({correct}/{total})",
			quiz_no_questions: "No hay preguntas de cuestionario configuradas para este reto.",
			quiz_question_heading: "Pregunta",
			quiz_answers_aria: "Opciones de respuesta",
			quiz_select_answer: "Elige tu respuesta",
			quiz_submit_answer: "Enviar respuesta",
			quiz_answer_submitted: "Respuesta enviada",
			quiz_change_until_time_end: "Puedes cambiar tu respuesta hasta que termine el tiempo.",
			quiz_result_teams_pct: "{count}/{total} · {pct}%",
			quiz_waiting_play: "Espera a que el instructor inicie la ronda del reto.",
			fair_prize_question_heading: "Pregunta",
			fair_prize_slider_aria: "Control deslizante de rango de precio",
			fair_prize_range_from: "Desde",
			fair_prize_range_to: "Hasta",
			fair_prize_your_guess: "Tu estimación",
			fair_prize_select_value: "Arrastra el control para indicar tu mejor respuesta",
			fair_prize_submit_answer: "Enviar respuesta",
			fair_prize_answer_submitted: "Respuesta enviada",
			fair_prize_change_until_time_end: "Puedes cambiar tu estimación hasta que termine el tiempo.",
			fair_prize_no_questions: "No hay rondas de precio justo configuradas para este reto.",
			fair_prize_correct_answer: "Respuesta correcta",
			fair_prize_result_your_guess: "Tu estimación",
			fair_prize_result_no_adjustment: "No has ajustado tu estimación.",
			fair_prize_legend_correct: "Correcta",
			fair_prize_legend_your_team: "Tu equipo",
			fair_prize_legend_others: "Otros",
			fair_prize_all_team_answers: "Respuestas de todos los equipos",
			fair_prize_no_team_answers: "Aún no hay respuestas de equipos",
			fair_prize_teams_count: "{n} equipos",
			fair_prize_teams_label: "equipos",
			quiz_correct_answer: "Respuesta correcta",
			challenge_result_badge: "Resultado",
			rules_fair_prize_badge: "Reto de precio justo",
			rules_timeline_badge: "Reto de línea temporal",
			rules_quiz_badge: "Reto tipo cuestionario",
			rules_section_kicker: "Reto",
			rules_quiz_type: "Opción múltiple",
			rules_timeline_type: "Ordenar",
			rules_fair_prize_type: "Estimación",
			rules_quiz_intro:
				"{count} preguntas. Responde antes de que acabe el tiempo: cuanto más rápido aciertes, más puntos suma tu equipo.",
			rules_timeline_intro:
				"{count} rondas de ordenación. Coloca los pasos en la secuencia correcta antes de que acabe el tiempo.",
			rules_fair_prize_intro:
				"{count} rondas de estimación. Adivina el valor más cercano antes de que acabe el tiempo.",
			rules_quiz_demo_title: "Toca una respuesta",
			rules_quiz_demo_hint:
				"Pulsa la tarjeta de color que creas correcta. Puedes cambiar tu respuesta hasta que acabe el tiempo.",
			rules_timeline_demo_title: "Arrastra para ordenar",
			rules_timeline_demo_hint:
				"Mantén pulsada cada tarjeta y arrástrala arriba o abajo hasta dejar la secuencia correcta. Puedes cambiar el orden hasta que acabe el tiempo.",
			rules_timeline_step_a: "Paso A",
			rules_timeline_step_b: "Paso B",
			rules_timeline_step_c: "Paso C",
			rules_fair_prize_demo_title: "Ajusta el número",
			rules_fair_prize_demo_hint:
				"Desliza el control o usa los botones − y + para afinar tu estimación. Gana quien más se acerque.",
			player_challenges_heading: "Tus retos",
			player_challenges_subtitle: "Elige un reto cuando el anfitrión lo active en la ruleta para jugar.",
			player_challenge_active_now: "Activo ahora",
			player_challenge_not_active: "Este reto aún no está activo. Espera a que el anfitrión lo saque en la ruleta.",
			player_challenge_open_play: "Jugar ahora",
			player_challenge_view_details: "Ver detalles",
			player_back_to_challenges: "Todos los retos"
		},
	
		forms: {
			please_input: "Introduce una cantidad",
		
			please_select: "Selecciona una opción",
			please_select_filter: "Selecciona un filtro",
		},
	},
	errors: {
		required: "Este campo es obligatorio",
		invalid_email: "El email no es válido",
		invalid_url: "La URL no es válida",
		invalid_number: "El número no es válido",
		field_invalid: "Campo {field} incorrecto",
		connection: "Error de conexión con el servidor",
		unauthorized: "No tienes permiso para realizar esta acción",
		not_found: "No se ha encontrado el registro",
		conflict: "Ya existe un registro con estos datos",
		server: "Ha ocurrido un error en el servidor"
	},
	messages: {
		error_generating_pdf: "No se ha podido generar el PDF",
		join_game_success: "Has entrado al juego correctamente",
		success: "Éxito",
		download_completed: "Descarga Completada",
		error: "Error",
		error_downloading: "No se pudo descargar el archivo",
		game_paused: "Juego pausado",
		game_resumed: "Juego reanudado",
		round_pass: "Ronda saltada",
		canceled: "Cancelado",
		deleted: "Eliminado",
		updated: "Actualizado",
		added: "añadido",
		monitor_added: "Monitor añadido correctamente",
		monitor_updated: "Monitor actualizado correctamente",
		monitor_not_added: "No se ha podido añadir al monitor",
		score_ok: "Puntuación enviada correctamente",
		score_not_ok: "No se pudo enviar la puntuación",
		score_add: "Pon una puntuación",
		select_team: "Selecciona un equipo",
		team_error: "No se ha podido añadir el equipo",
		team_correctly: "Equipo {msg} correctamente",
		incorrect_fields: "Hay campos incorrectos en el formulario",
		tapas_succesfull_updated: "Actividad Guerra de Tapas actualizada correctamente",
		tapas_not_succesfull_updated: "No se ha podido actualizar la actividad Guerra de Tapas",
		tapas_succesfull_added: "Actividad Guerra de Tapas añadida correctamente",
		tapas_not_succesfull_added: "No se ha podido añadir la actividad Guerra de Tapas",
		select_passed: "Selección saltada",
		link_copied: "Enlace copiado",
		votes_deleted: "Votos eliminados correctamente",
		votes_not_deleted: "No se han podido eliminar los votos",
		money_updated: "Dinero actualizado",
		teams_added: "Equipos añadidos correctamente",
		game_started: "Juego Empezado",
		deleted_ok: "Eliminado correctamente",
		deleted_not_ok: "No se ha podido elminiar",
		updated_not_ok: "No se ha podido actualizar",
		select_challenge: "Selecciona un reto",
		challenges: "Retos",
		template: "Plantilla",
		ipad_hunt_not_succesfull_added: "No se ha podido añadir la actividad Ipad Hunt",
		challenge_activated: "Reto Activado",
		points_updated: "Puntos Actualizados",
		time_updated: "Tiempo Actualizado",
		correctly_scored: "Puntuado correctamente",
		incorrectly_scored: "No se ha podido puntuar correctamente",
		team: "Equipo",
		action_updated_ok: "Actividad Action Challenge actualizada correctamente",
		action_updated_not_ok: "No se ha podido actualizar la actividad Action Challenge",
		action_added_ok: "Actividad Action Challenge añadida correctamente",
		action_added_not_ok: "No se ha podido añadir la actividad Action Challenge",
		route_created: "Ruta Creada",
		route_deleted: "Ruta Borrada",
		route_saved: "Ruta Guardada",
		saved: "Guardado",
		select_category: "Escoger una categoria",
		must_select: "Debes selecionar top1 y top 2",
		vote_sent: "Votación enviada",
		vote_error: "Error al votar",
		correct_score: "Puntuado Correctamente",
		incorrect_score: "No se ha podido puntuar correctamente",
		game_reactivated: "Juego Reactivado",
		game_finished: "Juego Finalizado",
		write_quesiton: "Escribe una pregunta",
		event_deleted: "Evento borrado",
		select_activity: "Debes selecionar la actividad",
		event_created: "Evento creado",
		event_updated: "Evento editado",
		event_not_created: "No se ha podido crear el evento",
		utq_updated: "Actividad Rally actualizada correctamente",
		utq_not_updated: "No se ha podido actualizar la actividad Rally",
		url_copied: "URL copiada",
		url_error: "Error al copiar la URL",
		error_deleting_event: "No se ha podido eliminar el evento",
		reopened: "Reabierto",
		finished: "Finalizado",
		cancelled: "Cancelado",
		closed_booking: "Reserva Cerrada",
		canceled_booking: "Reserva Cancelada",
		file_removed: "Archivo eliminado",
		upload_file: "Subir archivo",
		file_uploaded: "Archivo subido",
		error_upload: "No se ha podido subir el archivo",
		no_id_model: "Hay que guardar el formulario antes de subir archivos",
		no_files_readonly: "De momento no hay archivos para descargar.",
		favorite_challenge_added: "Reto añadido a favoritos",
		favorite_challenge_removed: "Reto eliminado de favoritos",
		next_act: "Siguiente caso",
		added_points: "Puntos añadidos",
		added_time: "Tiempo añadido",
		given_object: "Objeto dado",
		given_information: "Información dada",
		write_question: "Escribe una pregunta"
	},
	player_views: {
		event: {},
		home: {
			user_registered: "Usuario registrado",
			active_events: "Ver eventos activos",
			insert_code: "Introducir código evento // equipo",
			qr_scan: "Escanear QR",
			code_event: "Código evento",
			code_team: "Código equipo",
			event_not_exist: "El evento no existe",
			team_not_exist: "El equipo no existe"
		},
		player_view: {}
	},
	public_views: {
		tapas: {
			presentation_tapas: {
				end: "Fin de la presentación"
			},
			ranking_tapas: {
				round_ends: "Ronda finaliza",
				team_turn: "Turno equipo",
				choice_type: "Tipo elección",
				choice_round: "Ronda elección",
				total_round: "Ronda total",
				time_preparation: "Tiempo de elaboración"
			},
			results_tapas: {}
		},
		utq: {
			ranking_utq: {
				round_ends: "Ronda finaliza",
				points_upper: "PUNTOS",
				points_abbr: "pts",
				challenge_upper: "CHALLENGE",
				challenges_done: "Retos",
				team_upper: "EQUIPO",
				team_fallback: "Equipo",
				position_upper: "POSICIÓN",
				round_time_left: "Tiempo restante ronda",
				no_teams: "Aún no hay equipos en el ranking"
			},
			results_utq: {
				team_upper: "EQUIPO",
				position_upper: "POSICIÓN",
				points_upper: "PUNTOS"
			}
		},
		collabo: {
			last_buildings: "Últimas Construcciones",
			buildings: "Construcciones",
			join_event: "Unirme al evento",
			next_objective: "Siguiente objetivo",
			objective: "Objetivo",
			all_objectives_completed: "Todos los objetivos completados",
			objective_completed: "Se ha completado el objetivo",
			new_buildings_unlocked: "NUEVOS EDIFICIOS DESBLOQUEADOS",
			skyscraper_unlocked: "Ya podéis construir el rascacielos",
			ranking_title_default: "Ranking"
		},
		actionChallenge: {
			ranking_action_challenge: {
				press_button_view_ranking: "Dale al botón para ver el ranking",
				view_ranking: "Ver ranking"
			}
		},
		team_picker: {
			title: "Lista de equipos",
			tooltip: "Genera un enlace para que los equipos puedan escoger en qué equipo quieren participar",
			subtitle: "Encuentra y visualiza equipos buscando por nombre o ID",
			search_placeholder: "Buscar por nombre o ID de equipo...",
			no_teams_found: "No se encontraron equipos",
			try_adjusting_search: "Intenta ajustar tu búsqueda",
			no_teams_available: "No hay equipos disponibles",
			showing_results: "Mostrando {count} de {total} equipos",
			points: "Puntos",
			id: "ID"
		},
		event_lobby: {
			join_game: "Entrar al juego",
			player_photo_optional: "Foto del jugador (Opcional)",
			title: "Sala de espera"
		}
	},
	ipadHunt: {
		initial_position: "Posición inicial",
		finish_position: "Posición final",
		ipadHunt_player: {
			must_challenge: "Reto obligatorio",
			modal_password: "Escribe la contraseña que te proporcionará el miembro de staff",
			modal_error_download_title: "Contenido no guardado",
			modal_error_download_text: "Volver a descargar el contenido",
			modal_download_content_title: "Descargando contenido",
			modal_download_content_text: "Descargando contenido",
			modal_error_location_title: "No está disponible la localización",
			modal_error_location_text: "Activa los permisos de localización o ponte en contacto con el organizador del evento.",
			content_correct: "Contenido descargado correctamente",
			content_incorrect: "Hay errores en el contenido, volver a descargar",
			delete_content: "Volver a descargar el contenido",
			test_camera: "Probar cámara",
			answer_send: "Vuestra respuesta se ha registrado correctamente. En los próximos minutos recibiréis los puntos correspondientes.",
			match: "Relacionar",
			take_photo: "Hacer foto",
			take_video: "Grabar video",
			error_wrong_password: "La contraseña es incorrecta",
			error_no_answer: "No se ha detectado ninguna respuesta",
			error_order: "Tienes que ordenar las respuestas",
			modal_test_title: "TEST",
			modal_test_localization_correct: "Localización correcta",
			modal_test_localization_incorrect: "La localización no está disponible",
			modal_test_ok: "Test correcto",
			reload_app: "Actualizar aplicación",
			challenge_camera: "Cámara reto",
			modal_challenge_title: "TEST",
			modal_challenge_localization_correct: "Localización correcta",
			modal_challenge_localization_incorrect: "Localización no disponible",
			modal_challenge_ok: "Reto completado correctamente",
			reset_challenge: "Reiniciar reto inicial",
			challenge_reset: "Reto reiniciado correctamente",
			no_active_challenge: "No se encontró ningún reto activo",
			show_start_challenges: "Mostrar Retos Iniciales",
			start_challenges_shown: "Reto(s) se mostrarán nuevamente",
			no_start_challenges: "No se encontraron retos iniciales",
			scan_qr: "Escanear QR",
			qr_scanned: "¡Código QR Escaneado!",
			error_invalid_qr: "Código QR inválido",
			error_challenge_not_found: "Reto no disponible",
			error_challenge_already_done: "Este reto ya está completado",
			challenges_blocked: "Retos Bloqueados",
			challenges_blocked_message: "El monitor ha bloqueado todos los retos. Por favor, espera a que se desbloqueen los retos."
		},
		game_master_ranking: {
			name: "Nombre",
			points: "Puntos",
			challenges_done: "Retos Realizados",
			last_challenge: "Último reto"
		},
	
		initial_position_tooltip: "Define el punto de referencia alrededor del que se situarán inicialmente todas las pruebas. También se establece como punto final de la actividad, aunque después puede modificarse.",
		finish_position_tooltip: "Se establece como punto final de la actividad, aunque después puede modificarse.",
	},
	actionChallenge: {
		actionChallenge_player: {
			final_images: "Imagenes del juego",
			already_done: "Ya has hecho esta prueba",
			quiz_already_done: "Ya has hecho este cuestionario",
			category_completed: "Ya has hecho todos los cuestionarios de esta categoría",
			until: "Hasta",
			points: "Puntos",
			coins: "monedas",
			coins_won: "Monedas ganadas:",
			audio_error: "Tu navegador no soporta el formato de audio.",
			need_material: "En este reto necesitas material",
			continue: "CONTINUAR",
			send_response: "ENVIAR RESPUESTA",
			correct_response: "RESPUESTA CORRECTA",
			correct_responses: "RESPUESTAS CORRECTAS",
			incorrect_response: "RESPUESTA INCORRECTA",
			money_won: "Dinero ganado:",
			response: "Respuesta",
			multiple_answers_hint: "( PODÉIS SELECCIONAR VARIAS RESPUESTAS )",
			btn_match: "Match",
			successes: "Aciertos",
			similarity: "La palabra coincide un {similarity_percentage}% a las palabras correctas",
			category_no_elements: "No hay elementos en esta categoría",
			not_started: "EL EVENTO TODAVÍA NO HA EMPEZADO",
			challenge_warning: "Tras comprar un reto, ve a buscar el material a la tienda para completarlo.",
			pick_material: "VE A BUSCAR EL MATERIAL A LA TIENDA PARA EMPEZAR ESTE RETO",
			challenge_send: "LA RESPUESTA HA SIDO ENVIADA Y SERÁ EVALUADA POR EL MONITOR",
			return_material: "DEVUELVE EL MATERIAL A LA TIENDA PARA SELECCIONAR EL SIGUIENTE RETO",
			points_won: "Puntos ganados",
			wrong_answer: "RESPUESTA INCORRECTA",
			game_finished: "LA PARTIDA HA FINALIZADO",
			return_material_finish: "DEVUELVE EL MATERIAL DEL RETO A LA TIENDA",
			no_material: "En estos momentos no hay material suficiente para hacer este reto",
			no_money: "No tienes dinero suficiente para comprar este reto",
			shop: "Tienda",
			obejcts_buy: "Material comprado",
			quantity: "Cantidad",
			modal_buy_text: "Comprar {object} por {dinero}$",
			error_item_buy_no_money: "No tienes suficiente dinero",
			error_item_buy_no_stock: "No queda stock",
			error_item_buy_can_not_more: "No puedes compar más material de este",
			ok_item_buy: "Material comprado, ya puedes recogerlo",
			construction_name: "Nombre de la construcción",
			construction_photo: "Foto de la construcción",
			total_points: "Puntos totales",
			ranking_hidden: "El ranking está oculto",
			ranking_cooperative: "Ranking cooperativo",
			ranking_slides: "Diapositivas"
		},
		ranking_action_challenge: {
			press_button_view_ranking: "Dale al botón para ver el ranking",
			view_ranking: "Ver ranking"
		}
	},
	cluedo_ai: {
		cluedo_ai_player: {
			game_paused: "El juego está pausado, espera a que el monitor lo reanude.",
			evaluated: "Evaluado las respuestas",
			upload_team_picture: "Subir foto de equipo",
			no_picture: "No hay foto de equipo",
			scan_qr_code: "Escanear QR",
			key_information: "Información clave",
			key_information_missing: "Información clave faltante",
			no_key_information: "No hay información clave",
			objects: "Objetos",
			characters: "Personajes",
			game_intro: "Introducción del caso",
			question: "Pregunta",
			game_finished: "Juego terminado",
			questions_modified: "Respuestas sin guardar",
			init_conversation: "Envia un mensaje para iniciar la conversación con {character_name}",
			interrogate: "Interrogar",
			explore: "Explorar",
			view_intro: "Ver introducción",
			send_answer: "Guardar respuestas",
			conclusions: "Conclusiones",
			not_started: "El juego todavía no ha comenzado",
			updated: "Respuestas actualizadas",
			answers_sent: "Respuestas enviadas",
			answers_not_sent: "No se han podido enviar las respuestas",
			no_answer: "No hay respuesta",
			new_object_unlocked: "Nuevo objeto desbloqueado",
			new_character_unlocked: "Nuevo personaje desbloqueado",
			model_3d: "Modelo 3D",
			answer_placeholder: "Respuesta...",
			voice_record: "Hablar (pulsa para grabar y otra vez para transcribir)",
			voice_stop: "Detener grabación y transcribir",
			voice_listening: "Escuchando…",
			voice_transcribing: "Transcribiendo audio…",
			voice_error_microphone_unavailable: "El micrófono no está disponible en este dispositivo.",
			voice_error_microphone_denied: "Permiso de micrófono denegado.",
			voice_error_empty_recording: "No se ha grabado audio.",
			voice_error_empty_transcript: "No se ha entendido el audio.",
			voice_error_transcription_failed: "No se pudo transcribir el audio. Inténtalo de nuevo.",
			found_object: "HAS ENCONTRADO UN OBJETO",
			found_character: "HAS ENCONTRADO UN PERSONAJE",
			error_invalid_qr: "Código QR inválido",
			error_wrong_case_title: "Caso incorrecto",
			error_wrong_case_message: "Este código QR pertenece a otro caso. Solo se pueden escanear códigos QR del caso activo en este momento."
		}
	},
	collabo: {
		player_collabo: {
			seconds_to_show_error_modal: "Espera {seconds} segundos",
			error: "Error",
			incorrect_answer: "Respuesta incorrecta. Por favor, inténtalo de nuevo.",
			correct: "Correcto",
			correct_answer: "Respuesta correcta",
			last_buildings: "Últimas Construcciones",
			buildings: "Construcciones",
			join_challenge: "Estoy en {challenge_name}",
			go_zone: "VE A LA ZONA DEL RETO <span class='text-primary'>{challenge_name}</span> PARA EMPEZAR.",
			confirm_join_challenge: "¿Confirmas que estás en el roll-up de <span class='text-primary'>{challenge_name}</span>?",
			players_joined: "Jugadores",
			cancel: "Cancelar",
			confirm_join: "Confirmar",
			points_added: "Puntos añadidos correctamente",
			points_add_error: "Error al añadir puntos",
			challenge_joined: "Te has unido al reto correctamente",
			challenge_join_error: "Error al unirse al reto",
			construction_in_progress: "Construcción En Progreso",
			material_needed: "Material Necesario",
			delete_construction: "Eliminar Construcción",
			cancel_construction: "Cancelar Construcción",
			join_construction: "QR para unirse",
			material_in_construction: "Material en construcción:",
			available: "Disponible",
			in_construction: "En Construcción",
			player_join: "Unirse Jugador",
			helpToBuild: "Ayudar a Construir",
			build: "Construir",
			not_enough_materials: "Edificios Insuficientes",
			build_construction: "Construir Edificio",
			build_construction_description: "¿Quieres empezar a construir este edificio?",
			new_material_received: "Nuevo Material Recibido",
			accept: "Aceptar",
			join_construction_description: "Escanea el código QR para unirte a esta construcción",
			delete_construction_description: "¿Estás seguro de que quieres eliminar esta construcción?",
			delete: "Eliminar",
			cancel_construction_description: "¿Estás seguro de que quieres cancelar la ayuda con esta construcción?",
			construction_finished: "Construcción Finalizada",
			construction_finished_description: "¡La construcción ha sido completada!",
			success_construction: "Construcción Exitosa",
			building_id: "ID del Edificio",
			built_by: "CONSTRUIDO POR",
			just_now: "Ahora",
			some_minutes_ago: "Hace {minutes} minutos",
			more_than_hour_ago: "Hace menos de una hora",
			minute_ago: "MIN",
			minutes_ago: "MIN",
			hour_ago: "H",
			hours_ago: "H",
			day_ago: "DÍA",
			days_ago: "DÍAS",
			material_accepted: "Material aceptado correctamente",
			material_accept_error: "Error al aceptar material",
			material_added: "Material añadido correctamente",
			material_add_error: "Error al añadir material",
			construction_canceled: "Construcción cancelada correctamente",
			construction_cancel_error: "Error al cancelar construcción",
			construction_deleted: "Construcción eliminada correctamente",
			construction_delete_error: "Error al eliminar construcción",
			construction_started: "Construcción iniciada correctamente",
			construction_error: "Error al iniciar construcción",
			enter_number: "Introducir Número",
			submit: "Enviar",
			select_color: "Seleccionar Color",
			select_color_first: "Por favor, selecciona un color primero",
			saving: "Guardando...",
			no_recipe: "No hay receta disponible",
			your_components: "Tus Componentes",
			component_updated: "Componente actualizado correctamente",
			matrix_updated: "Matriz actualizada correctamente",
			matrix_update_error: "Error al actualizar matriz",
			your_resources: "Tus Recursos",
			or_enter_code: "O ingresa el código:",
			enter_3_letters: "Ingresa 3 letras",
			validate_code: "Validar Código",
			invalid_code: "Código inválido",
			code_not_found: "El código no corresponde a ninguna construcción disponible",
			code_label: "Código:",
			objective_done: "Objetivo cumplido",
			teams_in_construction: "Equipos en la construcción",
			participants_in_construction: "Participantes en la construcción",
			leading_team: "Líder"
		}
	},
	tapas: {
		change_main_ingredient: "Cambiar ingrediente principal",
		change_time: "Modificar tiempo",
		tapas_player: {
			new_challenge: "Nuevo reto",
			change_name: "Cambiar nombre",
			time_choose: "Tiempo para escoger",
			presentation_in: "Presentación en",
			final_presentation: "Presentación final",
			default_keyword: "Palabra clave",
			dish_name_PC: "Nombre de la paella",
			dish_name_Tapas: "Nombre de la tapa",
			dish_name_MS: "Nombre de la sangría",
			dish_name: "Nombre de ",
			dish_photo: "Foto de ",
			dish_photo_PC: "Foto de la paella",
			dish_photo_Tapas: "Foto de la tapa",
			dish_photo_MS: "Foto de la sangría",
			available_money: "Dinero disponible",
			choose_ingredient: "Escoger ingrediente",
			team_choosing: "Equipo eligiendo",
			choose_rice: "Escoger arroces",
			choose_plates: "Escoger platos",
			choose_plates_rices: "Escoger platos/arroces",
			choose_decoration: "Escoger decoración",
			change_team_name: "Cambiar nombre de equipo",
			buy_confirm: "Confirmar compra",
			meal_photo: "Foto de la comida",
			exit_event: "Salir del evento",
			answer_correct: "La respuesta es correcta",
			answer_incorrect: "La respuesta es incorrecta",
			name_changed: "Nombre cambiado",
			name_sent: "Nombre enviado",
			item_purhased: "Objeto comprado, ya puedes ir a recogerlo en la tienda",
			no_unit: "No hay unidades",
			password_incorrect: "La contraseña no es correcta",
			item_purchased: "Utensilio comprado",
			item_already_purchased: "Tu equipo ya ha comprado este artículo",
			team_photo: "Foto de equipo",
			ingredient_history: "Historial de Ingredientes",
			current_ingredients: "Ingredientes Actuales",
			shop_items: "Artículos de la Tienda",
			team_info: "Información del Equipo",
			team_name: "Nombre del Equipo",
			current_money: "Dinero Actual",
			not_set: "No establecido"
		}
	},
	modals: {
		upload_photo: {
			change_camera: "Cambiar cámara",
			upload_photo: "Subir foto",
			photo_success: "Foto enviada"
		}
	},
	stores: {
		tapas: {
			main_ingredient: "Ingrediente principal",
			global_winner: "Global",
			flavour_winner: "Sabor",
			presentation_winner: "Present.",
			defense_winner: "Defensa",
			money_winner: "Dinero",
			photo_tapa: "F. TAPA",
			photo_team: "F. EQUIPO",
			tapa: "TAPA",
			position: "POSICIÓN",
			points: "PUNTOS"
		}
	},
	erp: {
		booking: {
			reservation: "Reserva",
			client_link: "Link cliente",
			changes_pending: "Cambios pendientes de validar",
			changes_sent_title: "Cambios guardados",
			changes_sent_detail: "Tus cambios se han guardado y enviado correctamente. Ahora están pendientes de validación.",
			changes_sent_no_changes: "No había cambios nuevos que enviar.",
			calendar: {
				vendedor: "Vendedor",
				produccion: "Producción",
				select_vendedor: "Seleccionar vendedor",
				select_produccion: "Seleccionar producción",
				calendar: "Calendario",
				filters: "Filtros",
				calendar_filters: "Filtros del calendario",
				production_details: "Detalles producción",
				configure_fields: "Configurar campos",
				crm_id: "ID CRM",
				pax: "Pax",
				language: "Idioma",
				fundae: "FUNDAE",
				staff_number: "Número de monitores",
				teams_number: "Número de equipos",
				bookings: "Reservas",
				budgets: "Presupuestos",
				gamemasters: "Monitores",
				accepted: "ACEPTADO",
				to_check: "POR REVISAR"
			}
		},
		user_settings: {
			title: "Configuración de Usuario",
			change_password: "Cambiar Contraseña",
			new_password: "Nueva Contraseña",
			enter_new_password: "Ingrese la nueva contraseña",
			confirm_password: "Confirmar Contraseña",
			confirm_new_password: "Confirme la nueva contraseña",
			change_password_button: "Cambiar Contraseña",
			change_language: "Cambiar Idioma",
			language: "Idioma",
			select_language: "Seleccione un idioma",
			change_language_button: "Cambiar Idioma",
			password_required: "Por favor ingrese la nueva contraseña",
			password_min_length: "La contraseña debe tener al menos 8 caracteres",
			confirm_password_required: "Por favor confirme la nueva contraseña",
			passwords_not_match: "Las contraseñas no coinciden",
			password_changed_success: "Contraseña cambiada exitosamente.",
			password_change_error: "Error al cambiar la contraseña. Por favor, inténtelo de nuevo.",
			form_errors: "Por favor, corrija los errores en el formulario.",
			spanish: "Español",
			english: "Inglés",
			language_required: "Por favor seleccione un idioma",
			language_updated_success: "Idioma actualizado exitosamente.",
			language_update_error: "Error al actualizar el idioma. Por favor, inténtelo de nuevo.",
			select_valid_language: "Por favor, seleccione un idioma válido."
		},
		configuration: {
			integrations: {
				title: "Integraciones",
				subtitle: "Conecta herramientas externas con tu organización.",
				connected: "Conectado",
				not_connected: "No conectado",
				connect: "Conectar",
				disconnect: "Desconectar",
				company: "Empresa",
				connected_as: "Conectado como",
				api_token: "API token",
				api_token_placeholder: "Pega aquí tu API token de Pipedrive",
				api_token_help: "En Pipedrive: Ajustes personales → API → Personal API token.",
				slack_channels_title: "Canales de Slack",
				pipedrive_title: "Pipedrive",
				pipedrive_description: "Conecta Pipedrive para vincular oportunidades y reservas con tu CRM.",
				pipedrive_connected: "Pipedrive conectado",
				pipedrive_not_connected: "Pipedrive no conectado",
				pipedrive_connect_success: "Pipedrive conectado correctamente",
				pipedrive_connect_error: "No se pudo conectar Pipedrive. Revisa el API token.",
				pipedrive_disconnect_success: "Pipedrive desconectado",
				pipedrive_disconnect_error: "No se pudo desconectar Pipedrive"
			},
			organization: {
				slack_configuration: "Configuración de Slack",
				slack_install_description: "Instala la aplicación de Slack para recibir notificaciones de los eventos.",
				slack_connected: "Slack conectado",
				slack_not_connected: "Slack no conectado",
				event_notifications_channel: "Canal de notificaciones de eventos",
				staff_notifications_channel: "Canal de notificaciones de staff",
				select_channel: "Seleccionar canal",
				refresh_channels: "Actualizar canales",
				save_slack_config: "Guardar configuración de Slack",
				slack_config_saved: "Configuración de Slack guardada",
				error_saving_slack_config: "Error al guardar la configuración de Slack",
				channels_refreshed: "Canales actualizados",
				error_refreshing_channels: "Error al actualizar los canales",
				initial_position: "Posición Inicial para Eventos",
				initial_position_label: "Ubicación inicial",
				search_location: "Buscar ubicación...",
				error_loading_places: "Error al cargar el servicio de lugares",
				link_app: "Enlace de la aplicación",
				testing_link: "Enlace de pruebas juegos Online",
				testing_link_description: "Comparte este enlace con los clientes para que puedan comprobar su conexión y la configuración del dispositivo antes del evento.",
				booking_agent: "Agente IA",
				booking_agent_description: "Cuando está activo, el personal puede pedir en cada reserva un análisis con el Agente IA.",
				booking_agent_enabled: "Activar Agente IA en reservas",
				booking_agent_extra_prompt: "Instrucciones extra del prompt",
				booking_agent_extra_prompt_help: "Se añaden al prompt base del sistema. Úsalo para checklist o reglas propias de tu organización.",
				booking_agent_extra_prompt_placeholder: "Ej.: Revisar siempre contacto on-site, menú confirmado y parking.",
				open: "Abrir",
				organization_url: "URL de la organización",
				copy: "Copiar",
				users: "Usuarios",
				create_new_user: "Crear Nuevo Usuario",
				edit_user: "Editar Usuario",
				name: "Nombre",
				enter_name: "Ingrese el nombre",
				role: "Rol",
				cancel: "Cancelar",
				save: "Guardar",
				email: "Email",
				enter_email: "Ingrese el email",
				password: "Contraseña",
				enter_password: "Ingrese la contraseña",
				confirm_password: "Confirmar Contraseña",
				confirm_password_placeholder: "Confirme la nueva contraseña",
				create: "Crear",
				confirm_deletion: "Confirmar Eliminación",
				delete_user_confirmation: "¿Está seguro que desea eliminar al usuario {name}?",
				delete: "Eliminar",
				organization_qr_code: "Código QR de la Organización",
				administrator: "Administrador",
				facilitator: "Monitor",
				edit: "Editar",
				actions: "Acciones",
				url_copied: "URL copiada al portapapeles",
				user_updated: "Usuario actualizado exitosamente",
				error_updating_user: "Error al actualizar el usuario",
				user_created: "Usuario creado exitosamente",
				error_creating_user: "Error al crear el usuario",
				user_deleted: "Usuario eliminado exitosamente",
				error_deleting_user: "Error al eliminar el usuario",
				select_role: "Seleccione un rol",
				available_languages: "Idiomas disponibles",
				select_languages: "Seleccione los idiomas",
				default_language: "Idioma por defecto",
				select_default_language: "Seleccione el idioma por defecto",
				at_least_one_language_required: "Debe seleccionarse al menos un idioma",
				make_all_pdfs: "Generar todos los PDFs",
				make_all_pdfs_cooldown: "La generación de PDF ya está en progreso. Puede comenzar de nuevo 45 minutos después de la última ejecución.",
				make_all_pdfs_started: "La generación de PDF ha comenzado.",
				make_all_pdfs_error: "No se pudo iniciar la generación de PDF. Por favor, inténtelo de nuevo.",
				personalization: "Personalización",
				monitor_info: "Información de monitor",
				field_label: "Etiqueta del campo",
				field_type: "Tipo de campo",
				field_options: "Opciones del campo (separadas por comas)",
				visible_to_staff: "Visible para el staff",
				required: "Obligatorio",
				active: "Activo",
				add_field: "Añadir campo",
				booking_defaults: "Campos por defecto de reserva",
				booking_default_field: "Campo de reserva",
				booking_default_value: "Valor por defecto",
				booking_default_files: "Archivos plantilla",
				booking_default_save_first_upload: "Guarda la configuración antes de subir ficheros plantilla.",
				booking_default_json_hint: "Introduce JSON válido (array u objeto).",
				fundae_enabled: "Activar campos FUNDAE",
				contracts_enabled: "Activar contratos en reservas",
				contracts: "Contratos",
				booking_custom_fields: "Campos personalizados de reserva",
				booking_custom_fields_hint: "Estos campos aparecen en la reserva y se pueden usar como variables del contrato.",
				contract_template: "Plantilla del contrato",
				contract_template_hint: "Escribe el contrato e inserta variables de la reserva o campos del cliente donde quieras. Los campos del cliente no aparecen solos: hay que insertarlos en el texto.",
				insert_booking_variable: "Variable o campo",
				insert_variable: "Insertar variable",
				add_client_field: "Crear campo del cliente",
				client_field_button_tooltip: "Crea un campo que el cliente rellenará y lo inserta en el contrato en la posición del cursor.",
				client_field_tooltip: "Texto de ayuda (tooltip)",
				contract_client_fields: "Campos del cliente",
				contract_client_fields_hint: "Campos que rellena el cliente. Créalos aquí e inserta su variable en el texto del contrato donde quieras.",
				contract_template_expand: "Mostrar texto del contrato",
				contract_template_collapse: "Minimizar texto del contrato",
				client_field_option_prefix: "Cliente",
				signing_fields_title: "Campos para firmar",
				signing_fields_hint: "Nombre y firma siempre se piden al firmar. Aquí solo añades campos extra de texto (p. ej. DNI).",
				signing_field_required: "Obligatorio",
				add_signing_text_field: "Añadir campo de texto",
				signing_type_name: "Nombre",
				signing_type_signature: "Firma dibujada",
				signing_type_text: "Texto",
				signature_template_title: "Párrafo de firma",
				signature_template_hint: "Texto que se añade al contrato cuando el cliente firma. Inserta variables de firma y de los campos de firma.",
				insert_signature_variable: "Variable de firma",
				insert_into_signature: "Insertar en el párrafo de firma",
				signature_var_signer_name: "Nombre del firmante",
				signature_var_signed_datetime: "Fecha y hora",
				signature_var_signed_date: "Fecha",
				signature_var_signed_time: "Hora",
				signature_var_signature_image: "Imagen de la firma",
				signature_var_signed_by_label: "Etiqueta «Firmado por» (idioma reserva)",
				signature_var_date_label: "Etiqueta «Fecha y hora» (idioma reserva)",
				signature_var_company_signer_name: "Nombre firmante empresa",
				signature_var_company_signature_image: "Firma de la empresa",
				company_signature_title: "Firma de la empresa",
				company_signature_hint: "Nombre y firma de tu empresa. Al firmar el contrato aparecen automáticamente a la derecha de la firma del cliente.",
				company_signer_name: "Nombre del firmante (empresa)",
				company_signature_draw: "Dibujar firma de la empresa",
				company_signature_clear: "Quitar firma de la empresa",
				booking_field_type_text: "Texto",
				booking_field_type_textarea: "Texto largo",
				booking_field_type_number: "Número",
				booking_field_type_date: "Fecha",
				booking_field_type_select: "Selector",
				booking_field_type_checkbox: "Casilla",
				notifications: "Notificaciones",
				notifications_channels: "Canales",
				notifications_channel_email: "Correo",
				notifications_channel_whatsapp: "WhatsApp",
				notifications_list: "Notificaciones",
				notifications_enabled: "Activa",
				notifications_channels_for_event: "Enviar por",
				notifications_trigger_monitor_activity_offer: "Cuando un monitor recibe una oferta de actividad",
				notifications_trigger_monitor_accept_reject: "Cuando un monitor acepta o rechaza una actividad",
				notifications_whatsapp_inbound: "Respuesta automática de WhatsApp",
				notifications_whatsapp_inbound_hint:
					"Texto que se envía cuando un monitor escribe al número de WhatsApp.",
				notifications_event_list: "Notificaciones de evento",
				notifications_event_hint:
					"Avisos programados respecto al inicio del evento, de 3 días antes a 3 días después.",
				notifications_event_add: "Añadir notificación",
				notifications_event_edit: "Editar notificación",
				notifications_event_name: "Nombre",
				notifications_event_name_required: "Cada notificación de evento necesita un nombre.",
				notifications_event_when: "Cuándo",
				notifications_event_when_before: "Antes del evento",
				notifications_event_when_after: "Después del evento",
				notifications_event_days: "Días",
				notifications_event_hours: "Horas",
				notifications_event_minutes: "Minutos",
				notifications_event_message: "Texto",
				notifications_event_recipients: "Destinatarios",
				notifications_event_recipient_sales_responsible: "Responsable de venta",
				notifications_event_recipient_production_responsible: "Responsable de producción",
				notifications_event_recipient_responsible_monitor: "Responsable de monitores",
				notifications_event_recipient_monitors: "Monitores",
				field_type_text: "Texto",
				field_type_select: "Selección",
				field_type_multiselect: "Selección múltiple",
				field_type_checkbox: "Casilla",
				field_type_phone_communications: "Teléfono comunicaciones"
			},
			credit_consumption: {
				title: "Consumo de créditos",
				subtitle: "Uso de créditos de la organización, totales de facturación y estado de pago.",
				entries: "Registros",
				total_credits: "Créditos totales",
				paid_amount: "Importe pagado",
				pending_amount: "Importe pendiente",
				filters: "Filtros",
				date_from: "Fecha desde",
				date_to: "Fecha hasta",
				activity_type: "Tipo de actividad",
				payment_status: "Estado del pago",
				apply: "Aplicar",
				consumption_details: "Detalle del consumo",
				rows_count: "{count} filas",
				col_date: "Fecha",
				col_event: "Evento",
				col_activity: "Actividad",
				col_credits: "Créditos",
				col_unit_price: "Precio unitario",
				col_amount: "Importe",
				col_paid: "Pagado",
				status_paid: "Pagado",
				status_pending: "Pendiente",
				empty_state: "No hay consumo de créditos con los filtros actuales.",
				filter_all: "Todos",
				filter_paid: "Pagado",
				filter_pending: "Pendiente",
				all_activities: "Todas las actividades",
				activity_fallback: "Actividad {id}",
				load_failed: "No se pudo cargar el consumo de créditos."
			}
		}
	},
	events: {
		active_events: "Eventos activos",
		event: "Actividad",
		game: "App",
		day: "Fecha",
		actions: "Acciones",
		view_event: "Ver actividad",
		enter: "Entrar",
		finish: "Finalizar",
		reopen: "Reabrir",
		delete_event: "Eliminar evento",
		are_you_sure: "¿Estás seguro?",
		accept: "Aceptar",
		cancel: "Cancelar",
		no_content: "No hay contenido",
		no_content_in_activity: "No hay contenido en esta actividad",
		edit: "Editar",
		download: "Descargar",
		delete: "Eliminar",
		search_name: "Buscar por nombre..."
	},
	client: {
		budgets: "Presupuestos",
		bookings: "Reservas",
		billed: "Facturado"
	},
	qr_scanner: {
		camera_permission_denied: "ERROR: Permiso de cámara denegado",
		no_camera_found: "ERROR: No se encontró cámara en el dispositivo",
		unable_to_start_camera: "ERROR: No se puede iniciar la cámara"
	},
	map: {
		search_address: "Buscar una dirección...",
		locate_button: "Centrar mapa",
		switch_map_type: "Cambiar tipo de mapa"
	},
	musicalBingo: {
		staff: {
			skip_challenge: "Saltar reto",
			song_challenge: "Canción del reto",
			song_post_challenge: "Canción del post reto",
			winner_team: "Equipo ganador",
			challenge_explaining: "Explicando el reto",
			volume_up: "Volumen +",
			volume_down: "Volumen -",
			command_send: "Comando enviado",
			next_step_send: "Siguiente paso enviado",
			controls: "Controles",
			status: "Estado",
			start_game: "Iniciar juego",
			waiting_game: "Esperando juego",
			waiting_set: "Selecionando Bingo",
			next_step: "Siguiente paso",
			start_bingo: "Iniciar Bingo",
			game_start_soon: "Bingo listo para empezar",
			start_bingo_public: "Iniciar Bingo",
			playing_song: "Reproduciendo la canción",
			result_song: "Resultado canción",
			pause_song: "Pausar canción",
			resume_song: "Reanudar canción",
			repeat_song: "Repetir canción",
			song_result: "Resultado canción",
			playing_challenge: "Reproduciendo reto",
			remaining_time: "Tiempo restante",
			team_answers: "Respuestas de los equipos",
			correct_answers: "Respuestas correctas",
			players: "jugadores",
			song: "Canción",
			next_image: "Siguiente imagen",
			bingo_select: "Seleccionar Bingo",
			final_ranking: "Finalizar ranking",
			final_photo: "Finalizar foto",
			bingo_done: "Bingos finalizado",
			finish_game: "Finalizar bingo",
			bingo_finished: "Bingo finalizado",
			stop_bingo: "Detener bingo",
			live_view: "Vista en directo",
			exclude_teams: "Equipos que no deben ganar este bingo",
			exclude_teams_placeholder: "Seleccionar equipos (opcional)",
			exclude_teams_all_error: "Al menos un equipo debe poder ganar"
		},
		public_view: {
			re_take_photo: "Volver a hacer fotografía",
			select_option: "Selecciona la opción mas votada",
			quiz_results: "Resultados del quiz",
			challenge_results: "Resultados retos",
			quiz: "Quiz",
			fill: "Rellena la frase",
			two_vs_two: "Reto por equipos",
			one_vs_all: "Encuesta de equipo",
			photo: "Fotografía",
			waiting_game: "Esperando juego",
			selecting_bingo: "Seleccionando Bingo",
			bingo_start_soon: "El Bingo empezará en breve",
			playing: "Adivina la canción",
			ranking: "Ranking",
			seconds: "segundos",
			points: "puntos",
			answer_sent: "Respuesta enviada",
			answer_not_sent: "No se ha podido enviar la respuesta",
			send_answer: "Enviar respuesta",
			remaining_time: "Tiempo restante",
			team_answers: "Respuestas de los equipos",
			correct_answers: "Respuestas correctas",
			players: "jugadores",
			photo_show: "Fotos de los equipos",
			go_to_stage: "Un representante de tu equipo debe subir al escenario",
			go_to_stage_all: "Que suba todo el equipo al escenario",
			this_groups_to_stage: "Esperando a que los equipos vayan al escenario",
			challenge_start_soon: "Espera a que los representantes elegidos suban al escenario",
			turn_of_team: "Turno del equipo ",
			vote_of_team: "Hora de votar ",
			placement: "Equipo posicionándose",
			draw: "Empate",
			fill_write_answer: "Rellenar respuesta",
			fill_answer: "Rellenar la respuesta",
			quiz_write_answer: "Contestando el quiz",
			photo_write_answer: "Enviando las fotos",
			upload_photo: "Hacer fotografía",
			photo_saved: "Foto guardada",
			fill_answer_placeholder: "Escribe la respuesta"
		},
		ranking_musical_bingo: {
			press_button_view_ranking: "Dale al botón para ver el ranking",
			view_ranking: "Ver ranking"
		},
		player: {
			bingo_start_soon: "Bingo empezará en breve",
			selecting_bingo: "Seleccionando Bingo",
			no_picture: "No hay foto de equipo",
			upload_team_picture: "Subir foto de equipo",
			not_started: "La actividad todavía no ha empezado",
			photo_show: "Fotos de los equipos",
			song_marked: "Canción marcada",
			answered: "Respondido",
			correct_song: "Canción correcta",
			wrong_song: "Canción incorrecta",
			error_marking_song: "Error al marcar la canción",
			bingo_finished: "Bingo finalizado",
			winner_team: "Equipo ganador",
			photo_screen: "Fotos de los equipos",
			play: "Reproducir",
			pause: "Pausar",
			restart: "Reiniciar",
			start_game: "INICIAR JUEGO",
			audio_permission_message: "Haz clic en el botón de abajo para habilitar la reproducción de audio del juego.",
			tab_muted_warning: "⚠️ La Pestaña del Navegador Está Silenciada",
			tab_muted_instructions: "Por favor, desactiva el silencio de la pestaña del navegador haciendo clic en el icono del altavoz en la pestaña para habilitar la reproducción de audio.",
			no_team_responding: "No ha respondido ningún equipo correctamente",
			final_ranking: "Ranking Final"
		}
	},
	summaries: {
		description: "Descarga y gestiona resúmenes e informes de monitores",
		monitor_summaries: "Resúmenes de Monitores",
		download_monitor_summary: "Descargar Resumen de Monitores",
		select_month: "Seleccionar Mes",
		select_month_description: "Elige el mes para el cual quieres descargar el informe de resumen de monitores.",
		download: "Descargar",
		download_success: "Descarga Exitosa",
		download_success_detail: "El resumen de monitores para {month} se ha descargado correctamente.",
		download_error: "Error de Descarga",
		download_error_detail: "Ocurrió un error al descargar el resumen de monitores. Por favor, inténtalo de nuevo."
	},
	catalan: "Catalán",
	staff_page: {
		title: "Registros de personal",
		description: "Ver y gestionar los registros de maestros de juegos por rango de fechas.",
		date_range: "Rango de fechas",
		select_year: "Año",
		select_month: "Mes",
		all_months: "Todos los meses",
		filter_by_staff: "Filtrar por personal",
		filter_by_accepted: "Estado aceptado",
		all_staff: "Todo el personal",
		filter_by_paid: "Estado de pago",
		all: "Todo",
		paid: "Pagado",
		not_paid: "No pagado",
		booking: "Reserva",
		booking_name: "Nombre de la reserva",
		date: "Fecha",
		staff: "Personal",
		salary: "Salario",
		accepted: "Aceptado",
		responsible: "Responsable",
		paid_status: "Estado de pago",
		comments: "Comentarios",
		mark_selected_paid: "Marcar seleccionado como pagado",
		mark_selected_not_paid: "Marcar seleccionado como no pagado",
		mark_all_paid: "Marcar todos como pagados",
		mark_all_not_paid: "Marcar todos como no pagados",
		update_success: "Registros actualizados con éxito",
		update_error: "Error al actualizar registros. Por favor, inténtelo de nuevo.",
		select_records: "Seleccionar uno o más registros",
		loading: "Cargando...",
		no_records: "No se encontraron registros para el período seleccionado.",
		records_updated: "{count} registro(s) actualizado(s)",
		total_salary: "Salario total",
		total_salary_to_be_paid: "Total de salario a pagar"
	},
	gm_activities_page: {
		description: "Consulta tus actividades, pagos y reservas pendientes.",
		activities: "Actividades",
		pending_reservation: "Reserva pendiente"
	}
}